// ============================================================
// PromoterHQ — Translation strings
// Supported: vi (Vietnamese), en (English), zh (Chinese Simplified)
// ============================================================

const translations = {
  vi: {
    // ── Common ──────────────────────────────────────────────
    "common.save":            "Lưu thay đổi",
    "common.saving":          "Đang lưu...",
    "common.cancel":          "Hủy",
    "common.edit":            "Sửa",
    "common.delete":          "Xóa",
    "common.create":          "Tạo",
    "common.creating":        "Đang tạo...",
    "common.close":           "Đóng",
    "common.confirm":         "Xác nhận",
    "common.loading":         "Đang tải...",
    "common.calculating":     "Đang tính toán...",
    "common.refresh":         "Làm mới",
    "common.export":          "Xuất Excel",
    "common.exportAll":       "⬇ Xuất tất cả",
    "common.exporting":       "Đang xuất...",
    "common.send":            "Gửi",
    "common.sending":         "Đang gửi...",
    "common.approve":         "✓ Duyệt",
    "common.reject":          "✕ Từ chối",
    "common.approve_short":   "Duyệt",
    "common.reject_short":    "Từ chối",
    "common.noData":          "Chưa có dữ liệu",
    "common.all":             "Tất cả",
    "common.yes":             "Có",
    "common.no":              "Không",
    "common.name":            "Họ tên",
    "common.email":           "Email",
    "common.password":        "Mật khẩu",
    "common.month":           "Tháng",
    "common.date":            "Ngày",
    "common.status":          "Trạng thái",
    "common.note":            "Ghi chú",
    "common.action":          "Thao tác",
    "common.search":          "Tìm kiếm",
    "common.filter":          "Lọc",
    "common.clearFilter":     "Bỏ lọc",
    "common.total":           "Tổng",
    "common.detail":          "Chi tiết",
    "common.back":            "Quay lại",
    "common.success":         "Thành công",
    "common.error":           "Lỗi",
    "common.warning":         "Cảnh báo",
    "common.recalc":          "🔄 Tính lại",
    "common.addNew":          "+ Thêm mới",

    // ── Auth ─────────────────────────────────────────────────
    "auth.login":             "Đăng nhập",
    "auth.logout":            "Đăng xuất",
    "auth.logging_in":        "Đang đăng nhập...",
    "auth.email":             "Email",
    "auth.password":          "Mật khẩu",
    "auth.forgot":            "Quên mật khẩu?",
    "auth.back_to_login":     "← Quay lại đăng nhập",
    "auth.reset_title":       "Đặt lại mật khẩu",
    "auth.reset_desc":        "Nhập email tài khoản của bạn để nhận link đặt lại mật khẩu.",
    "auth.reset_send":        "Gửi email đặt lại",
    "auth.reset_sending":     "Đang gửi...",
    "auth.reset_success":     "✅ Email đặt lại mật khẩu đã được gửi. Vui lòng kiểm tra hộp thư.",
    "auth.change_pw":         "Đổi mật khẩu",
    "auth.current_pw":        "Mật khẩu hiện tại",
    "auth.new_pw":            "Mật khẩu mới",
    "auth.confirm_pw":        "Xác nhận mật khẩu mới",
    "auth.pw_min":            "Tối thiểu 6 ký tự",
    "auth.pw_mismatch":       "Mật khẩu xác nhận không khớp",
    "auth.pw_changed":        "✅ Đã đổi mật khẩu thành công!",
    "auth.pw_change_btn":     "Đổi mật khẩu",
    "auth.pw_changing":       "Đang đổi...",
    "auth.login_subtitle":    "Quản lý promoter MSI Vietnam",
    "auth.reset_pw_for":      "Gửi email reset mật khẩu đến",

    // ── Navigation ───────────────────────────────────────────
    "nav.dashboard":          "Dashboard",
    "nav.sales":              "Doanh số",
    "nav.attendance":         "Chấm công",
    "nav.salary":             "Tính lương",
    "nav.salary_short":       "Lương",
    "nav.promoters":          "Promoters & Shops",
    "nav.targets":            "Target & Thưởng",
    "nav.holidays":           "Ngày lễ",
    "nav.skus":               "SKU Laptop",
    "nav.bonus_rules":        "Quy tắc thưởng",
    "nav.notifications":      "Thông báo",
    "nav.training":           "Tài liệu",
    "nav.audit":              "Audit Log",
    "nav.checkin":            "Check-in/Out",
    "nav.my_sales":           "Nhập doanh số",
    "nav.sku_lookup":         "Tra cứu SKU",
    "nav.home":               "Trang chủ",
    "nav.more":               "Thêm",
    "nav.targets_sv":         "Set Target",
    "nav.salary_report":      "Báo cáo lương",
    "nav.send_notif":         "Gửi thông báo",
    "nav.administrator":      "Administrator",
    "nav.supervisor_label":   "Supervisor",

    // ── Language ─────────────────────────────────────────────
    "lang.switch":            "Ngôn ngữ",
    "lang.vi":                "🇻🇳 Tiếng Việt",
    "lang.en":                "🇬🇧 English",
    "lang.zh":                "🇨🇳 中文",

    // ── Dashboard ────────────────────────────────────────────
    "dash.title":             "Dashboard",
    "dash.subtitle":          "Tổng quan hệ thống",
    "dash.checkin_today":     "Đã check-in hôm nay",
    "dash.pending_sales":     "Sale chờ duyệt",
    "dash.pending_appeals":   "Giải trình chờ duyệt",
    "dash.total_promoters":   "Tổng promoter",
    "dash.of_promoters":      "/ {n} promoter",
    "dash.promoters":         "promoter",
    "dash.sales_this_month":  "Doanh số tháng này",
    "dash.approved_sales":    "đơn đã duyệt",
    "dash.pending_review":    "Chờ xử lý",
    "dash.quick_actions":     "Thao tác nhanh",
    "dash.go_approve":        "→ Duyệt ngay",
    "dash.go_appeals":        "→ Xem giải trình",

    // ── Sales ────────────────────────────────────────────────
    "sales.title":            "Doanh số",
    "sales.subtitle":         "Theo dõi tiến độ và lịch sử",
    "sales.subtitle_sv":      "Nhóm promoter của bạn",
    "sales.tab_progress":     "Tiến độ",
    "sales.tab_pending":      "Chờ duyệt",
    "sales.tab_detail":       "Chi tiết",
    "sales.tab_cancel":       "Yêu cầu hủy",
    "sales.request_cancel":   "Yêu cầu hủy",
    "sales.cancel_reason":    "Lý do hủy",
    "sales.approve_cancel":   "Duyệt hủy",
    "sales.reject_cancel":    "Từ chối",
    "sales.promoter":         "Promoter",
    "sales.shop":             "Shop",
    "sales.target_ds":        "Target DS",
    "sales.sold":             "Đã bán",
    "sales.hit_rate":         "Hit rate",
    "sales.progress":         "Tiến độ",
    "sales.target_he":        "Target HE",
    "sales.he_sold":          "HE đã bán",
    "sales.bonus_ds":         "Thưởng DS",
    "sales.bonus_he":         "Thưởng HE",
    "sales.not_reached":      "Chưa đạt",
    "sales.model":            "Model",
    "sales.serial":           "Serial",
    "sales.highend":          "Highend",
    "sales.sale_date":        "Ngày bán",
    "sales.submit_date":      "Ngày nộp",
    "sales.approver":         "Người duyệt",
    "sales.approve_all":      "Duyệt tất cả",
    "sales.no_pending":       "Không có đơn nào chờ duyệt ✓",
    "sales.no_data_month":    "Chưa có dữ liệu tháng này",
    "sales.submit_title":     "Nhập doanh số",
    "sales.submit_subtitle":  "Ghi nhận máy đã bán",
    "sales.add_sale":         "+ Thêm sale",
    "sales.history":          "Lịch sử",
    "sales.pending_badge":    "Đang chờ",
    "sales.approved_badge":   "Đã duyệt",
    "sales.rejected_badge":   "Từ chối",
    "sales.is_highend":       "Máy Highend?",
    "sales.ocr_hint":         "Chụp ảnh hoá đơn để tự điền",
    "sales.submit_btn":       "Nộp doanh số",
    "sales.submitting":       "Đang nộp...",
    "sales.no_history":       "Chưa có doanh số nào",

    // ── Attendance ───────────────────────────────────────────
    "att.title":              "Chấm công",
    "att.subtitle":           "Theo dõi và quản lý chấm công promoter",
    "att.subtitle_sv":        "Theo dõi chấm công nhóm của bạn",
    "att.tab_overview":       "Bảng tổng quan",
    "att.tab_detail":         "Chi tiết & Ảnh",
    "att.tab_appeals":        "Giải trình chờ duyệt",
    "att.tab_appeals_short":  "Giải trình",
    "att.checkin_today":      "Đã check-in hôm nay",
    "att.done_today":         "Đã hoàn thành ca",
    "att.checked_out":        "đã check-out",
    "att.not_yet":            "Chưa check-in",
    "att.absent_today":       "người vắng mặt",
    "att.days_standard":      "Ngày công chuẩn",
    "att.days_worked":        "Ngày đi làm",
    "att.holiday_days":       "Ngày lễ (×3)",
    "att.total_hours":        "Tổng giờ làm",
    "att.26_days":            "26 ngày",
    "att.days":               "ngày",
    "att.calendar":           "Lịch tháng",
    "att.summary":            "Tổng kết",
    "att.full":               "Đủ công",
    "att.partial":            "Thiếu giờ",
    "att.holiday":            "Ngày lễ",
    "att.absent":             "Vắng",
    "att.export_excel":       "⬇ Xuất Excel (bảng tháng)",
    "att.leave_type":         "Loại nghỉ",
    "att.leave_paid":         "Nghỉ có lương",
    "att.leave_annual":       "Phép năm",
    "att.mark_day":           "Đánh dấu ngày",
    "att.mark_work":          "Đủ công",
    "att.mark_work_note":     "Dùng khi app lỗi, promoter đã báo qua kênh chat — ngày này không có ảnh chấm công.",
    "att.mark_clear":         "Gỡ đánh dấu (trả về bình thường)",
    "att.mark_hint":          "Bấm để đánh dấu ngày nghỉ",
    "att.mark_overwrite":     "⚠ Ngày này đã có chấm công thật — đánh dấu sẽ xóa bản ghi đó.",
    "att.checkin_time":       "Check-in",
    "att.checkout_time":      "Check-out",
    "att.hours":              "Giờ",
    "att.photo_title":        "Ảnh chấm công",
    "att.no_photo":           "Không có ảnh",
    "att.reason":             "Lý do",
    "att.submitted_at":       "Gửi lúc",
    "att.reject_note":        "Ghi chú từ chối (tuỳ chọn)",
    "att.no_appeals":         "Không có giải trình nào chờ duyệt ✓",
    "att.appeal_title":       "Giải trình chấm công",
    "att.appeal_reason":      "Lý do giải trình",
    "att.appeal_send":        "Gửi giải trình",
    "att.appeal_sending":     "Đang gửi...",
    "att.appeal_sent":        "Đã gửi giải trình thành công",
    "att.appeal_limit":       "Đã dùng hết 2 lần giải trình tháng này",
    "att.approved_appeal":    "Đã duyệt giải trình",
    "att.missing_checkout":   "Thiếu checkout",
    "att.checkin_title":      "Check-in hôm nay",
    "att.checkout_title":     "Check-out",
    "att.already_checkin":    "Đã check-in hôm nay",
    "att.no_checkin":         "Chưa check-in hôm nay",
    "att.checkin_btn":        "📷 Chụp ảnh Check-in",
    "att.checkout_btn":       "📷 Chụp ảnh Check-out",
    "att.checking_in":        "Đang check-in...",
    "att.checking_out":       "Đang check-out...",
    "att.location_required":  "Cần bật GPS để check-in",
    "att.history_title":      "Lịch sử tháng",
    "att.export_single":      "⬇ Xuất Excel",
    "att.short":              "Thiếu",

    // ── Salary ───────────────────────────────────────────────
    "salary.title":           "Tính lương",
    "salary.subtitle":        "Báo cáo lương tháng",
    "salary.subtitle_sv":     "Lương nhóm promoter (chỉ xem)",
    "salary.base":            "Lương cơ bản",
    "salary.days_worked":     "Ngày công",
    "salary.holiday_days":    "Trong đó ngày lễ (×3)",
    "salary.work_pay":        "Lương công",
    "salary.sales_bonus":     "Thưởng DS",
    "salary.highend_bonus":   "Thưởng Highend",
    "salary.program_bonus":   "Thưởng chương trình",
    "salary.event_bonus":     "Thưởng sự kiện",
    "salary.total":           "Tổng lương",
    "salary.export_csv":      "⬇ Xuất CSV",
    "salary.no_data":         "Chưa có dữ liệu",
    "salary.detail_title":    "Chi tiết lương",
    "salary.holiday_suffix":  " (+{n} lễ)",
    "salary.bonus_rules":     "Quy tắc thưởng",
    "salary.bonus_rules_sub": "Cấu hình bậc thưởng DS và Highend",
    "salary.reset_default":   "🔄 Reset mặc định",
    "salary.save_rules":      "💾 Lưu quy tắc",
    "salary.add_tier":        "+ Thêm bậc",
    "salary.min_rate_pct":    "Hit rate tối thiểu (%)",
    "salary.bonus_amount":    "Mức thưởng (đ)",
    "salary.max_target_units":"Target tối đa (máy)",
    "salary.base_bonus":      "Thưởng base (đ)",
    "salary.over_bonus_per_unit": "Thưởng thêm/máy (đ)",
    "salary.sales_bonus_desc":"Thưởng theo % hoàn thành target DS",
    "salary.highend_bonus_desc": "Thưởng Highend theo số máy target",
    "salary.he_unit_rate":    "Thưởng mỗi máy HE (đ)",
    "salary.he_over_rate":    "Thưởng mỗi máy vượt target (đ)",
    "salary.he_model_desc":   "Thưởng theo từng máy HE bán ra + thưởng cao hơn khi vượt target cá nhân",

    // ── Promoters ────────────────────────────────────────────
    "prom.title":             "Tài khoản",
    "prom.subtitle":          "Quản lý promoter và supervisor",
    "prom.tab_promoters":     "👥 Promoters",
    "prom.tab_supervisors":   "🎖 Supervisors",
    "prom.add_promoter":      "+ Thêm promoter",
    "prom.add_supervisor":    "+ Thêm supervisor",
    "prom.create_title":      "Tạo tài khoản mới",
    "prom.edit_title":        "Cập nhật promoter",
    "prom.create_sv_title":   "Tạo tài khoản supervisor",
    "prom.shop_name":         "Tên shop",
    "prom.base_salary":       "Lương cơ bản (đồng)",
    "prom.create_btn":        "Tạo tài khoản",
    "prom.save_btn":          "Lưu thay đổi",
    "prom.reset_pw":          "🔑 Reset PW",
    "prom.assign":            "👥 Assign promoter",
    "prom.assign_title":      "Assign promoter →",
    "prom.assign_hint":       "Chọn promoter thuộc nhóm của supervisor này:",
    "prom.no_promoters":      "Chưa có promoter nào",
    "prom.no_supervisors":    "Chưa có supervisor nào",
    "prom.archive":           "Lưu trữ",
    "prom.restore":           "Khôi phục",
    "prom.archived_badge":    "Đã lưu trữ",
    "prom.show_archived":     "Xem đã lưu trữ",
    "prom.confirm_archive":   "Promoter này sẽ bị ẩn khỏi hệ thống. Dữ liệu lịch sử vẫn được giữ lại. Tiếp tục?",
    "prom.created_ok":        "Đã tạo tài khoản thành công",
    "prom.updated_ok":        "Đã cập nhật thành công",
    "prom.sv_created_ok":     "Đã tạo supervisor thành công",
    "prom.reset_confirm":     "Gửi email đặt lại mật khẩu đến",
    "prom.reset_ok":          "✅ Đã gửi email đến",
    "prom.assign_ok":         "Đã cập nhật nhóm cho",

    // ── Targets ──────────────────────────────────────────────
    "target.title":           "Target & Thưởng",
    "target.title_sv":        "Set Target",
    "target.subtitle":        "Quản lý mục tiêu doanh số",
    "target.subtitle_sv":     "Đặt mục tiêu doanh số cho promoter",
    "target.sell_target":     "Target DS",
    "target.he_target":       "Target HE",
    "target.not_set":         "Chưa đặt",
    "target.save_ok":         "Đã lưu target cho",

    // ── Holidays ─────────────────────────────────────────────
    "holiday.title":          "Ngày lễ",
    "holiday.subtitle":       "Quản lý ngày lễ quốc gia",
    "holiday.add":            "+ Thêm ngày lễ",
    "holiday.name":           "Tên ngày lễ",
    "holiday.date":           "Ngày",
    "holiday.multiplier":     "Hệ số lương",
    "holiday.no_holidays":    "Chưa có ngày lễ nào",
    "holiday.delete_confirm": "Xóa ngày lễ này?",

    // ── SKUs ─────────────────────────────────────────────────
    "sku.title":              "SKU Laptop",
    "sku.subtitle":           "Quản lý danh sách sản phẩm",
    "sku.subtitle_lookup":    "Tra cứu thông số kỹ thuật laptop MSI",
    "sku.add":                "+ Thêm SKU",
    "sku.model":              "Model",
    "sku.brand":              "Hãng",
    "sku.cpu":                "CPU",
    "sku.gpu":                "GPU",
    "sku.ram":                "RAM",
    "sku.ssd":                "SSD",
    "sku.lcd":                "Màn hình",
    "sku.battery":            "Pin",
    "sku.ports":              "Cổng kết nối",
    "sku.upgradeable":        "Nâng cấp",
    "sku.highend":            "Highend",
    "sku.no_skus":            "Chưa có SKU nào",
    "sku.delete_confirm":     "Xóa SKU này?",
    "sku.search_placeholder": "Tìm theo tên model...",

    // ── Notifications ────────────────────────────────────────
    "notif.title":            "Thông báo",
    "notif.subtitle":         "Gửi thông báo đến promoter",
    "notif.title_field":      "Tiêu đề",
    "notif.body":             "Nội dung",
    "notif.send_to":          "Gửi đến",
    "notif.all_promoters":    "Tất cả promoter",
    "notif.all_group":        "Toàn bộ nhóm ({n} người)",
    "notif.select_specific":  "Chọn cụ thể",
    "notif.select_promoters": "Chọn promoter",
    "notif.attachment":       "📎 Tệp đính kèm",
    "notif.send_btn":         "📢 Gửi thông báo",
    "notif.sent_ok":          "✅ Đã gửi thông báo thành công!",
    "notif.no_notifs":        "Không có thông báo nào",
    "notif.from_admin":       "Thông báo từ admin",
    "notif.empty_fields":     "Vui lòng nhập tiêu đề và nội dung.",
    "notif.select_at_least":  "Vui lòng chọn ít nhất 1 promoter.",
    "notif.placeholder_title":"Tiêu đề thông báo",
    "notif.placeholder_body": "Nội dung thông báo...",
    "notif.upload_file":      "📎 Đính kèm tệp (tuỳ chọn)",
    "notif.submit_title":     "Gửi thông báo đến promoter",
    "notif.all_supervisors":  "Tất cả supervisor",

    // ── Bonus Rules ──────────────────────────────────────────
    "bonus.title":            "Quy tắc thưởng",
    "bonus.subtitle":         "Cấu hình bậc thưởng doanh số và highend",
    "bonus.sales_tiers":      "Bậc thưởng Doanh số",
    "bonus.he_tiers":         "Bậc thưởng Highend",
    "bonus.programs":         "Chương trình thưởng",
    "bonus.min_rate":         "Hit rate tối thiểu (%)",
    "bonus.amount":           "Thưởng (đồng)",
    "bonus.add_tier":         "+ Thêm bậc",
    "bonus.program_name":     "Tên chương trình",
    "bonus.start_date":       "Từ ngày",
    "bonus.end_date":         "Đến ngày",
    "bonus.skus_list":        "Model áp dụng (cách nhau bằng dấu phẩy)",
    "bonus.per_unit":         "Thưởng mỗi máy (đồng)",
    "bonus.add_program":      "+ Thêm chương trình",
    "bonus.save_config":      "Lưu cấu hình",

    // ── Audit Log ────────────────────────────────────────────
    "audit.title":            "Audit Log",
    "audit.subtitle":         "Lịch sử hoạt động toàn hệ thống",
    "audit.type":             "Loại",
    "audit.actor":            "Người thực hiện",
    "audit.promoter":         "Promoter",
    "audit.detail":           "Chi tiết",
    "audit.time":             "Thời gian",
    "audit.sale_approved":    "Duyệt sale",
    "audit.sale_rejected":    "Từ chối sale",
    "audit.sale_cancelled":   "Hủy đơn đã duyệt",
    "audit.income_imported":  "Import thu nhập cũ",
    // ── Modules mới ──
    "audit.login": "Đăng nhập", "audit.logout": "Đăng xuất", "audit.password_changed": "Đổi mật khẩu",
    "audit.promoter_created": "Tạo promoter", "audit.promoter_updated": "Sửa promoter",
    "audit.promoter_archived": "Lưu trữ promoter", "audit.promoter_restored": "Khôi phục promoter",
    "audit.supervisor_created": "Tạo supervisor", "audit.assignment_changed": "Phân công supervisor",
    "audit.sale_submitted": "Nhập đơn", "audit.bonus_config_saved": "Sửa quy tắc thưởng",
    "audit.event_bonus_added": "Thêm khoán sự kiện", "audit.event_bonus_deleted": "Xóa khoán sự kiện",
    "audit.sku_added": "Thêm SKU", "audit.sku_deleted": "Xóa SKU",
    "audit.holiday_added": "Thêm ngày lễ", "audit.holiday_deleted": "Xóa ngày lễ",
    "audit.banner_saved": "Cập nhật banner", "audit.banner_deleted": "Xóa banner",
    "audit.training_added": "Thêm tài liệu", "audit.training_updated": "Sửa tài liệu", "audit.training_deleted": "Xóa tài liệu",
    "audit.sale_approval_reverted": "Thu hồi duyệt", "audit.target_approved": "Duyệt target",
    "audit.payroll_adjusted": "Điều chỉnh công", "audit.payroll_closed": "Chốt sổ lương", "audit.payroll_reopened": "Mở lại sổ lương",
    "x.status": "Trạng thái", "x.month": "Tháng", "x.note": "Ghi chú", "x.records": "bản ghi",
    "sales.status_pending2": "⏳ Chờ duyệt", "sales.status_approved2": "✓ Đã duyệt",
    "sales.status_rejected2": "✕ Bị từ chối", "sales.status_cancelled2": "🚫 Đã hủy",
    "sales.cancel_pending2": "🕓 Đang chờ hủy", "sales.rejected_badge": "bị từ chối",
    "sales.cancel_prompt": "Lý do hủy đơn (VD: khách bỏ cọc, không lấy máy):",
    "sales.search_ph": "🔍 Tìm theo tên promoter / model / serial...",
    "sales.orders_unit": "đơn", "sales.revert": "↩ Thu hồi",
    "sales.revert_hint": "Thu hồi duyệt — đơn quay về Chờ duyệt",
    "sales.revert_confirm": "Thu hồi duyệt đơn này? Đơn sẽ quay về trạng thái Chờ duyệt.",
    "sales.dup_serial": "⚠ Serial đã nộp trước:", "sales.dup_others": "đơn khác",
    "sales.toggle_he": "Bấm để đổi Highend", "sales.he_yes": "Có ✎", "sales.he_no": "Không ✎",
    "sales.locked_badge": "🔒 Đã chốt sổ", "sales.no_cancel_reqs": "Không có yêu cầu hủy nào",
    "sales.month_locked_view": "🔒 Tháng này đã chốt sổ lương — chỉ xem, không nhập thêm được.",
    "sales.closing_notice": "⏳ Đang bổ sung doanh số tháng trước — hạn chốt sổ: hết ngày 5.",
    "sales.locked_title": "Tháng này đã chốt sổ lương",
    "sales.locked_sub": "Chỉ xem lại lịch sử, không nhập thêm doanh số.",
    "sales.current_tag": "(hiện tại)",
    "ps.mode_list": "Chọn từ list", "ps.mode_search": "Tìm kiếm", "ps.mode_camera": "Chụp ảnh AI",
    "att.shift_label": "Loại ca hôm nay", "att.shift_full": "Ca đầy đủ ({h}h)", "att.shift_half": "Nửa ca ({h}h)",
    "att.shift_half_note": "Nửa ca tính 0,5 công, lương cứng giảm tương ứng",
    "att.msg_compress": "📦 Đang nén ảnh...", "att.msg_upload": "⬆ Đang tải ảnh lên & lấy vị trí GPS...", "att.msg_saving": "⏳ Đang ghi nhận...",
    "ah.pending_mode": "Chờ duyệt", "ah.history_mode": "📜 Lịch sử", "ah.count": "giải trình",
    "ah.none": "Không có giải trình nào", "ah.admin_note": "Ghi chú admin", "ah.reviewed_at": "Xử lý lúc",
    "ah.export": "⬇ Xuất CSV", "ah.st_pending": "Chờ duyệt", "ah.st_approved": "Đã duyệt", "ah.st_rejected": "Từ chối",
    "ah.legend_appeal": "Có giải trình (rê chuột xem chi tiết)",
    "attm.title": "⚙️ Điều chỉnh lương đặc biệt",
    "attm.leave_title": "🌴 Nghỉ có lương (quản lý duyệt)", "attm.leave_note": "Tính 1 công đầy đủ dù không check-in",
    "attm.event_title": "🎪 Khoán sự kiện ngoài giờ", "attm.event_name": "Tên sự kiện", "attm.amount": "Số tiền", "attm.add": "+ Thêm",
    "train.subtitle": "Tài liệu đào tạo & hướng dẫn", "train.add_title": "➕ Thêm tài liệu mới", "train.edit_title": "✏️ Sửa tài liệu",
    "train.date": "Ngày", "train.title_lb": "Tiêu đề", "train.content": "Nội dung",
    "train.link": "Đường dẫn (Google Drive / URL)", "train.save_change": "Lưu thay đổi", "train.add_btn": "Thêm tài liệu",
    "train.list": "Danh sách tài liệu", "train.none": "Chưa có tài liệu training nào", "train.open": "📄 Mở tài liệu",
    "train.need_title": "Vui lòng nhập tiêu đề", "train.saved": "✅ Đã lưu tài liệu", "train.del_confirm": "Xóa tài liệu này?",
    "tga.pending_title": "🎯 Target chờ duyệt", "tga.proposed_by": "Supervisor đề xuất",
    "tga.ds_prop": "DS đề xuất", "tga.he_prop": "HE đề xuất", "tga.ds_final": "DS duyệt", "tga.he_final": "HE duyệt",
    "tga.approve": "✓ Duyệt", "tga.adjusted": "(đã chỉnh)",
    "tga.hint": "💡 Có thể sửa số ở cột duyệt trước khi bấm Duyệt — supervisor và promoter sẽ được thông báo số cuối cùng.",
    "tga.sv_subtitle": "Đề xuất target — admin duyệt mới có hiệu lực",
    "tga.wait": "⏳ Chờ admin duyệt", "tga.approved": "✓ Đã duyệt", "tga.adj_note": "Admin điều chỉnh",
    "tga.locked": "🔒 Liên hệ admin để thay đổi", "tga.send": "Gửi đề xuất", "tga.propose": "+ Đề xuất",
    "pr.title": "📝 Review công & chốt sổ",
    "pr.subtitle": "Điều chỉnh công/thưởng trước khi chốt — áp dụng mọi nơi hiển thị lương.",
    "pr.close": "🔒 Chốt sổ tháng", "pr.reopen": "🔓 Mở lại sổ", "pr.closed_at": "✅ Đã chốt sổ",
    "pr.locked_note": "— phần điều chỉnh đã khóa.", "pr.pick_promoter": "— Chọn promoter —",
    "pr.days_ph": "± công (vd 1 hoặc -0.5)", "pr.bonus_ph": "± thưởng CT (đ)",
    "pr.note_ph": "Ghi chú (vd: phép năm, bù thưởng...)", "pr.save": "+ Lưu điều chỉnh",
    "pr.close_confirm": "Chốt sổ lương tháng này? Sau khi chốt sẽ khóa phần điều chỉnh.",
    "pr.reopen_confirm": "Mở lại sổ lương tháng này?",
    "salary.allowance": "Phụ cấp",
    "cc.title": "💼 Tổng chi phí công ty (qua agency)", "cc.config": "⚙ Cấu hình",
    "cc.si": "BHXH doanh nghiệp", "cc.hi": "BHYT doanh nghiệp", "cc.ui": "BH thất nghiệp",
    "cc.union": "Phí công đoàn", "cc.pai": "BH tai nạn",
    "cc.gross": "Tổng thu nhập nhân viên (Gross)", "cc.ins_total": "Tổng bảo hiểm & phí DN trả",
    "cc.mgmt": "Phí quản lý dịch vụ", "cc.total": "💰 TỔNG CHI PHÍ CÔNG TY",
    "cc.save_cfg": "💾 Lưu cấu hình", "cc.tiers": "Phí quản lý theo số nhân viên (đ/người/tháng)",
    "inc.title": "💰 Lịch sử thu nhập", "inc.m3": "3 tháng", "inc.m6": "6 tháng", "inc.m12": "12 tháng",
    "inc.sold": "Đã bán", "inc.net": "Thực nhận", "inc.detail": "chi tiết ⓘ", "inc.provisional": "(tạm tính)",
    "inc.total_range": "Tổng", "inc.loading": "Đang tính thu nhập...",
    "inc.modal_title": "Chi tiết thu nhập", "inc.work_pay": "Lương công",
    "inc.total_income": "Tổng thu nhập", "inc.pretax_note": "Đây là thu nhập trước thuế & bảo hiểm.",
    "inc.provisional_note": "Tạm tính tới hôm nay — số liệu còn thay đổi tới cuối tháng.",
    "inc.company_ins": "🏢 Bảo hiểm công ty đóng (không trừ vào lương)",
    "inc.emp_ins": "👤 Bảo hiểm bạn đóng (trừ vào lương)",
    "inc.total_company": "Tổng công ty đóng", "inc.total_emp": "Tổng bạn đóng",
    "inc.tax_section": "🧾 Thuế thu nhập cá nhân", "inc.taxable": "Thu nhập chịu thuế", "inc.pit": "Thuế TNCN",
    "inc.no_tax": "Thu nhập dưới 15.500.000đ → không phải nộp thuế TNCN.",
    "inc.no_breakdown": "Chi tiết thuế/bảo hiểm chưa có — admin cần import lại file Excel.",
    "inc.gross_lb": "Tổng thu nhập (Gross)",
    "x.workday": "công",
    "salary.export_xlsx": "⬇ Xuất Excel (đầy đủ)",
    "salary.ot_nontax": "OT không tính thuế",
    "inc.ot_exempt": "Trừ OT không tính thuế",
    "cc.usd_rate": "Tỷ giá USD (đ)",
    "pr.ot_ph": "± OT miễn thuế (đ)",
    "sales.locked_approve_warn": "Tháng {month} đã qua hạn chốt sổ. Duyệt hủy đơn này sẽ làm giảm doanh số và tiền thưởng của tháng đó — số liệu lương đã tính sẽ thay đổi. Vẫn tiếp tục?",
    "sales.locked_hint": "Tháng đã chốt sổ — chỉ admin duyệt hủy được. Bạn vẫn có thể từ chối yêu cầu.",
    "audit.sale_cancel_rejected": "Từ chối yêu cầu hủy",
    "sku.clear_filters": "Xóa bộ lọc",
    "cfg.ot_tiers": "Ba mức tăng ca (Điều 98 Bộ luật Lao động)",
    "cfg.ot_tiers_note": "% đơn giá giờ, chỉ tính khi promoter đăng ký trước và được duyệt (nếu bật duyệt).",
    "cfg.weekly_off_ot": "Làm ngày nghỉ hằng tuần",
    "cfg.weekly_off_ot_hint": "Luật quy định tối thiểu 200%. Ngày đó không tính là công thường.",
    "cfg.edit_in_ot_tab": "(chỉnh ở tab Giờ làm & tăng ca)",
    "ot.kind": "Loại tăng ca",
    "ot.kind_extra": "Làm thêm giờ",
    "ot.kind_weekly_off": "Làm ngày nghỉ tuần",
    "ot.note_weekly_off": "Đi làm vào ngày nghỉ hằng tuần: tính theo số giờ làm (tối đa số giờ đăng ký) ở mức tăng ca ngày nghỉ, không tính là công thường.",
    "pay.weekly_off": "Làm ngày nghỉ tuần",
    "cfg.rate_hours": "Số giờ quy đổi đơn giá",
    "cfg.rate_hours_hint": "Đơn giá giờ = lương cơ bản ÷ số ngày công chuẩn ÷ số giờ này (agency dùng 8)",
    "ot.kind_holiday": "Làm ngày lễ",
    "ot.note_holiday": "Ngày lễ: mọi giờ làm đều tính theo mức ngày lễ, nhưng phải đăng ký trước và được duyệt — không đăng ký thì không tính. Ghi tổng số giờ sẽ làm (kể cả giờ vượt ca).",
    "ot.admin_title": "Giờ tăng ca / làm ngày lễ (admin nhập)",
    "ot.admin_current": "Hiện có: {kind} {h}h",
    "ot.by_admin": "admin nhập",
    "ot.hours_unit": "giờ",
    "ot.admin_note_ph": "Ghi chú (vd: theo bảng lương agency)",
    "ot.admin_hint_holiday": "Tổng số giờ làm trong ngày lễ — toàn bộ tính theo mức ngày lễ. Số admin nhập được dùng đúng như nhập.",
    "ot.admin_hint_weekly_off": "Tổng số giờ làm vào ngày nghỉ hằng tuần — tính theo mức ngày nghỉ tuần, ngày đó không tính công thường.",
    "ot.admin_hint_extra": "Số giờ làm vượt ca chuẩn — tính theo mức tăng ca ngày thường.",
    "ot.admin_save": "Lưu (đã duyệt)",
    "ot.admin_update": "Cập nhật",
    "ot.admin_delete": "Xóa",
    "ot.admin_hours_err": "Số giờ phải lớn hơn 0 và không quá 24",
    "inc.probation_flat_note": "Đang trong thời gian thử việc — chưa tham gia bảo hiểm; thuế khấu trừ {pct}% trên tổng thu nhập (kể cả tăng ca), không giảm trừ gia cảnh.",
    "tax.probation_mode": "Thuế người thử việc",
    "tax.probation_flat": "Khấu trừ cố định % trên tổng thu nhập",
    "tax.probation_prog": "Lũy tiến, không giảm trừ gia cảnh",
    "tax.probation_flat_hint": "Cách agency đang làm: % × tổng Gross (tăng ca cũng tính), không giảm trừ.",
    "tax.probation_prog_hint": "Tính theo biểu lũy tiến như người chính thức nhưng không được giảm trừ gia cảnh.",
    "tax.probation_rate": "Mức khấu trừ thử việc",
    "tax.probation_min": "Không khấu trừ nếu thu nhập dưới",
    "nav.bonus_programs": "Chương trình thưởng",
    "prog.created_notified": "Đã tạo chương trình và gửi thông báo cho toàn bộ promoter & supervisor ✓",
    "bp.title": "Chương trình thưởng",
    "bp.sub_promoter": "Các chương trình thưởng theo model — số máy bạn bán được và tiền thưởng tạm tính",
    "bp.sub_supervisor": "Các chương trình thưởng theo model — số máy nhóm của bạn bán được",
    "bp.running": "Đang chạy",
    "bp.upcoming": "Sắp chạy",
    "bp.history": "Đã kết thúc",
    "bp.none_running": "Hiện không có chương trình nào đang chạy",
    "bp.none_ended": "Chưa có chương trình nào kết thúc",
    "bp.st_running": "Đang chạy",
    "bp.st_upcoming": "Sắp chạy",
    "bp.st_ended": "Đã kết thúc",
    "bp.days_left": "còn {n} ngày",
    "bp.last_day": "ngày cuối cùng",
    "bp.starts_in": "bắt đầu sau {n} ngày",
    "bp.per_unit": "Thưởng mỗi máy",
    "bp.my_units": "Bạn đã bán",
    "bp.my_bonus": "Thưởng tạm tính",
    "bp.team_units": "Nhóm của bạn ({team} promoter) đã bán: {n} máy",
    "bp.models": "Áp dụng cho {n} model",
    "bp.more": "+{n} model",
    "bp.less": "Thu gọn",
    "bp.view": "Xem chương trình",
    "bp.note": "Chỉ tính đơn đã được duyệt, đúng model và ngày bán nằm trong thời gian chương trình. Số chính thức theo bảng lương tháng.",
    "prog.edit": "Sửa",
    "prog.revoke": "Thu hồi",
    "prog.restore": "Khôi phục",
    "prog.edit_title": "Sửa chương trình: {name}",
    "prog.edit_note": "Lưu thay đổi sẽ gửi thông báo cho toàn bộ promoter & supervisor, nêu rõ những gì đã đổi. Thưởng trong bảng lương tính lại theo thông tin mới.",
    "prog.save_edit": "Lưu thay đổi & gửi thông báo",
    "prog.bad_dates": "Ngày kết thúc phải sau hoặc bằng ngày bắt đầu",
    "prog.updated_notified": "Đã cập nhật chương trình và gửi thông báo cho toàn bộ promoter & supervisor ✓",
    "prog.revoke_prompt": "Thu hồi chương trình \"{name}\"?\n\nSau khi thu hồi, chương trình KHÔNG còn tính thưởng cho bất kỳ đơn nào (kể cả đơn đã bán). Nếu chỉ muốn dừng sớm, hãy bấm Hủy và sửa ngày kết thúc.\n\nLý do thu hồi (sẽ gửi kèm thông báo, có thể để trống):",
    "prog.revoked_notified": "Đã thu hồi chương trình và gửi thông báo ✓",
    "prog.restore_confirm": "Áp dụng lại chương trình \"{name}\"? Thưởng sẽ được tính lại và gửi thông báo cho mọi người.",
    "prog.restored_notified": "Đã khôi phục chương trình và gửi thông báo ✓",
    "prog.revoked_title": "Chương trình đã thu hồi",
    "prog.reason": "Lý do",
    "prog.closed_warn": "Tháng {months} đã chốt sổ lương. Thay đổi này sẽ làm thay đổi tiền thưởng trong bảng lương đã chốt. Vẫn tiếp tục?",
    "bp.st_revoked": "Đã thu hồi",
    "bp.revoked_note": "Chương trình đã bị thu hồi, không còn tính thưởng",
    "bp.updated_at": "Cập nhật lúc {d}",
    "skm.upload": "Up file master",
    "skm.busy": "Đang xử lý...",
    "skm.panel_title": "Up file master thông số MSI",
    "skm.reading": "Đang đọc file {name}...",
    "skm.no_products": "Không tìm thấy SKU nào (Part No bắt đầu bằng 9S7-) trong file",
    "skm.found": "Sheet {sheet}: {n} SKU, {cols} cột thông số. Kiểm tra rồi bấm Xác nhận.",
    "skm.k_new": "mới",
    "skm.k_changed": "thay đổi",
    "skm.k_back": "bán lại",
    "skm.k_same": "không đổi",
    "skm.k_leaving": "ngừng cung cấp",
    "skm.leaving_note": "Các SKU không còn trong master sẽ được đánh dấu \"Ngừng cung cấp\": ẩn khỏi tra cứu của promoter, doanh số và chương trình cũ vẫn giữ nguyên.",
    "skm.skipped": "Bỏ qua {n} dòng có Part No không bắt đầu bằng 9S7-",
    "skm.keep_note": "Highend và ghi chú admin đã chỉnh trên SKU đang có được giữ nguyên. SKU mới tự nhận Highend theo GPU.",
    "skm.confirm": "Xác nhận {n} SKU",
    "skm.applying": "Đang lưu dữ liệu...",
    "skm.done": "Xong: +{added} mới, ↺ {updated} cập nhật, ⛔ {disc} ngừng cung cấp.",
    "skm.current": "Master hiện tại: {name} · {n} SKU · {d}",
    "skm.none": "Chưa up file master thông số nào",
    "skm.st_active": "Đang cung cấp",
    "skm.st_disc": "Ngừng cung cấp",
    "skm.st_all": "Tất cả SKU",
    "skm.master_cols": "Cột master",
    "skm.empty": "Chưa có SKU. Bấm \"📤 Up file master\".",
    "skm.remap_confirm": "Cập nhật lại các cột trên bảng SKU theo cấu hình mới, dùng thông số master đã lưu (không cần up lại file)?",
    "skm.remapped": "Đã cập nhật {n} SKU theo cấu hình mới.",
    "spec.msi_standard": "Thông số chuẩn MSI",
    "spec.show_all": "Xem tất cả thông số",
    "spec.hide_all": "Thu gọn",
    "spec.no_master": "SKU này chưa có trong file master thông số — hiện thông tin cơ bản.",
    "nav.reports": "Báo cáo bán hàng",
    "rpt.title": "Báo cáo bán hàng",
    "rpt.subtitle": "Tổng quan theo promoter, model và phân khúc qua nhiều tháng — so với target",
    "rpt.from": "Từ tháng",
    "rpt.to": "Đến tháng",
    "rpt.last_n": "{n} tháng",
    "rpt.all_promoters": "Tất cả promoter",
    "rpt.units": "Tổng máy bán",
    "rpt.months": "tháng",
    "rpt.vs_target": "Đạt target",
    "rpt.highend": "Máy Highend",
    "rpt.active_promoters": "Promoter có số liệu",
    "rpt.trend": "Doanh số theo tháng",
    "rpt.sold": "Đã bán",
    "rpt.tab_promoter": "Theo promoter",
    "rpt.tab_model": "Theo model",
    "rpt.tab_mix": "Phân khúc",
    "rpt.promoter_hint": "Mỗi ô: máy đã bán / target, % đạt và Highend. Bấm vào tên promoter để xem chi tiết từng tháng.",
    "rpt.total": "Tổng",
    "rpt.hit": "đạt",
    "rpt.near": "gần đạt",
    "rpt.miss": "chưa đạt",
    "rpt.imported": "số nhập",
    "rpt.imported_note": "Chữ nghiêng: tháng cũ lấy theo số liệu đã import (không có chi tiết model).",
    "rpt.model_search": "Tìm model hoặc phân khúc...",
    "rpt.segment": "Phân khúc",
    "rpt.no_sales": "Không có đơn đã duyệt trong khoảng này",
    "rpt.model_note": "Chỉ tính đơn đã duyệt nhập trong app. Cột Promoter: số promoter đã bán model đó.",
    "rpt.classify_by": "Phân loại theo",
    "rpt.by_segment": "Dòng máy (Segment)",
    "rpt.by_series": "Nhóm (Gaming / Business)",
    "rpt.whole_range": "Cả khoảng đã chọn",
    "rpt.mix": "Cơ cấu",
    "rpt.mix_note": "Phân khúc lấy từ thông số SKU (file master). Model không khớp SKU nào xếp vào \"Chưa phân loại\"; phân khúc nhỏ gộp vào \"Khác\".",
    "rpt.unknown": "Chưa phân loại",
    "rpt.other": "Khác",
    "rpt.top_models": "Model bán nhiều nhất",
    "prom.salary_from": "Mức lương mới áp dụng từ tháng",
    "prom.salary_from_note": "Các tháng trước tháng này vẫn tính theo mức cũ ({old} đ). Bảng lương tháng này và các tháng sau tính theo mức mới.",
    "prom.salary_saved": "Đã lưu mức lương mới, áp dụng từ tháng {month}",
    "prom.salary_history": "Lịch sử lương cơ bản",
    "prom.salary_initial": "Mức ban đầu",
    "prom.salary_from_m": "từ {m}",
    "prom.salary_past_warn": "Áp dụng lùi từ tháng {month}: bảng lương các tháng đã qua (kể cả tháng đã chốt sổ) sẽ tính lại theo mức mới. Tiếp tục?",
    "nav.settings": "Cấu hình",
    "cfg.title": "Cấu hình",
    "cfg.subtitle": "Mọi quy tắc tính công, lương, thuế và chi phí — một chỗ duy nhất",
    "cfg.tab_work": "Giờ làm & tăng ca",
    "cfg.tab_holiday": "Ngày lễ, Tết & nghỉ có lương",
    "cfg.tab_bonus": "Thưởng",
    "cfg.tab_tax": "Thuế & bảo hiểm",
    "cfg.tab_cost": "Chi phí agency",
    "cfg.tab_rules": "Quy định khác",
    "cfg.effective_from": "Áp dụng từ tháng",
    "cfg.editing_existing": "Đang sửa phiên bản áp dụng từ {month}. Lưu sẽ ghi đè phiên bản này.",
    "cfg.creating_new": "Chưa có phiên bản riêng cho {month} — lưu sẽ tạo phiên bản mới, áp dụng từ {month} trở đi. Các tháng trước giữ nguyên quy tắc cũ.",
    "cfg.save": "Lưu, áp dụng từ {month}",
    "cfg.saved": "Đã lưu. Quy tắc mới áp dụng từ tháng {month}.",
    "cfg.past_warn": "Tháng {month} đã qua. Lưu sẽ làm thay đổi số lương của {month} và các tháng sau đó. Tiếp tục?",
    "cfg.delete_confirm": "Xóa phiên bản áp dụng từ {month}? Các tháng đó sẽ quay về phiên bản trước.",
    "cfg.history": "Lịch sử thay đổi",
    "cfg.no_versions": "Chưa có phiên bản nào — toàn bộ các tháng đang tính theo quy tắc cũ.",
    "cfg.from": "Từ",
    "cfg.legacy_note": "Các tháng trước phiên bản đầu tiên tính theo quy tắc cũ (ca 8h, lễ ×3, chưa có OT) để khớp số lương đã trả.",
    "cfg.standard_days": "Số ngày công chuẩn / tháng",
    "cfg.standard_days_hint": "Lương ngày = lương cơ bản ÷ số này",
    "cfg.standard_hours": "Giờ làm chuẩn / ngày",
    "cfg.standard_hours_hint": "Làm đủ số giờ này là đủ công; vượt mới xét tăng ca",
    "cfg.half_shift": "Giờ của nửa ca",
    "cfg.half_shift_hint": "Nửa ca tính 0,5 công",
    "cfg.tolerance": "Dung sai thiếu giờ",
    "cfg.tolerance_hint": "Thiếu không quá số giờ này vẫn tính đủ công (0 = phải đủ giờ)",
    "cfg.ot_rate": "Tăng ca ngày thường",
    "cfg.ot_rate_hint": "% đơn giá giờ — luật quy định tối thiểu 150%",
    "cfg.ot_approval": "Đơn tăng ca phải được quản lý duyệt mới tính tiền",
    "cfg.ot_tax_exempt": "Tiền tăng ca và tiền làm ngày lễ được miễn thuế TNCN (Luật TNCN 2025)",
    "cfg.example_work": "Lương cơ bản 6.500.000đ → lương ngày {daily}đ, đơn giá giờ {hourly}đ (÷ {h} giờ), 1 giờ tăng ca = {ot}đ",
    "cfg.holiday_paid": "Lương ngày lễ",
    "cfg.holiday_paid_hint": "% lương ngày — được hưởng dù đi làm hay không",
    "cfg.holiday_ot": "Làm ngày lễ, Tết, nghỉ có lương",
    "cfg.holiday_ot_hint": "% đơn giá giờ, cho mọi giờ làm ngày lễ đã đăng ký — luật tối thiểu 300%, chưa kể lương ngày lễ",
    "cfg.example_holiday": "Nghỉ ngày lễ: {off}% lương ngày · Đi làm ngày lễ: {on}% lương ngày",
    "cfg.holiday_list_note": "Danh sách ngày lễ có hiệu lực ngay, không theo phiên bản tháng.",
    "cfg.people": "người",
    "cfg.person": "người",
    "cfg.closing_day": "Ngày chốt sổ",
    "cfg.closing_day_hint": "Tháng trước còn sửa doanh số, duyệt hủy… tới hết ngày này",
    "cfg.max_appeals": "Số giải trình được duyệt tối đa / tháng",
    "cfg.max_appeals_hint": "Mỗi promoter",
    "cfg.remind_hour": "Giờ nhắc check-out",
    "cfg.remind_hour_hint": "Gửi thông báo nếu promoter chưa check-out",
    "ot.title": "Đăng ký tăng ca",
    "ot.hours": "Số giờ tăng ca",
    "ot.note": "Chỉ phần làm vượt {h} tiếng mới tính tăng ca, tối đa bằng số giờ đăng ký.",
    "ot.reason_ph": "Ví dụ: chương trình khuyến mãi, kiểm kho…",
    "ot.submit": "Gửi đăng ký",
    "ot.registered": "Đã đăng ký tăng ca {h}h",
    "ot.st_pending": "chờ duyệt",
    "ot.st_approved": "đã duyệt",
    "ot.withdraw": "Rút đơn",
    "ot.pending_title": "Đăng ký tăng ca chờ duyệt",
    "pay.incl_holiday": "gồm {n} ngày lễ",
    "pay.holiday_pay": "Lương ngày lễ",
    "pay.holiday_ot": "Làm ngày lễ",
    "pay.ot": "Tăng ca",
    "audit.payroll_config_saved": "Lưu cấu hình",
    "audit.payroll_config_deleted": "Xóa phiên bản cấu hình",
    "audit.ot_requested": "Đăng ký tăng ca",
    "audit.ot_approved": "Duyệt tăng ca",
    "audit.ot_rejected": "Từ chối tăng ca",
    "audit.ot_withdrawn": "Rút đơn tăng ca",
    "att.st_full": "Đủ công",
    "att.st_missing": "Thiếu check-in/out",
    "att.st_short": "Thiếu giờ",
    "att.st_holiday": "Ngày lễ",
    "att.st_annualLeave": "Nghỉ phép năm",
    "att.st_unpaidLeave": "Nghỉ không phép",
    "att.st_weeklyOff": "Nghỉ tuần",
    "att.st_future": "Chưa tới",
    "lv.title": "Đăng ký nghỉ",
    "lv.type": "Loại nghỉ",
    "lv.unpaid": "Nghỉ không phép",
    "lv.annual_note": "Trừ vào phép năm, vẫn được tính 1 công.",
    "lv.unpaid_note": "Không tính công, không hưởng lương ngày đó.",
    "lv.reason": "Lý do",
    "lv.reason_ph": "Ví dụ: việc gia đình, khám bệnh...",
    "lv.approval_note": "Đơn sẽ được gửi tới quản lý. Ngày nghỉ chỉ có hiệu lực sau khi được duyệt.",
    "lv.submit": "Gửi đơn",
    "lv.book_hint": "Bấm ngày tương lai để đăng ký nghỉ",
    "lv.pending_hint": "Đơn xin nghỉ đang chờ quản lý duyệt",
    "lv.pending_short": "Chờ duyệt",
    "lv.pending_title": "Đơn xin nghỉ chờ duyệt",
    "lv.approve": "Duyệt",
    "lv.reject": "Từ chối",
    "audit.leave_requested": "Xin nghỉ",
    "audit.leave_approved": "Duyệt đơn nghỉ",
    "audit.leave_rejected": "Từ chối đơn nghỉ",
    "inc.probation_note": "Đang trong thời gian thử việc — chưa tham gia bảo hiểm, và chưa được giảm trừ gia cảnh.",
    "inc.meal_exempt": "Trừ tiền ăn ca miễn thuế",
    "inc.personal_ded": "Giảm trừ bản thân",
    "inc.dependent_ded": "Giảm trừ người phụ thuộc",
    "inc.taxable_base": "Thu nhập tính thuế",
    "cc.ins_base": "Lương đóng BH", "cc.insured": "Đóng BH",
    "cc.show_detail": "▸ Chi tiết theo người", "cc.hide_detail": "▾ Thu gọn",
    "cc.detail_note": "Bấm ô lương để ghi đè mức đóng riêng tháng này · Bỏ tick để loại khỏi diện đóng BH",
    "cc.export_detail": "⬇ Xuất CSV đối chiếu",
    "cc.probation_until": "Thử việc đến",
    "cc.under14_note": "Dưới 14 ngày công trong tháng — luật cho phép không đóng BH tháng này",
    "tax.title": "🧾 Cấu hình thuế TNCN & bảo hiểm",
    "tax.legal_note": "Luật TNCN 2025 (109/2025/QH15) · NQ 110/2025/UBTVQH15 · NĐ 253/2026/NĐ-CP",
    "tax.personal_ded": "Giảm trừ bản thân (đ/tháng)",
    "tax.dependent_ded": "Giảm trừ người phụ thuộc (đ/tháng)",
    "tax.meal_cap": "Trần ăn ca miễn thuế (đ/tháng)",
    "tax.probation_months": "Thời gian thử việc (tháng)",
    "tax.emp_si": "BHXH người LĐ (%)", "tax.emp_hi": "BHYT người LĐ (%)", "tax.emp_ui": "BHTN người LĐ (%)",
    "tax.emp_total": "NLĐ đóng", "tax.brackets": "Bậc thuế lũy tiến", "tax.tier": "Bậc",
    "tax.up_to": "Đến (đ/tháng)", "tax.tiers_count": "bậc thuế",
    "tax.up_to_note": "Để trống ô \"Đến\" ở bậc cuối cùng = không giới hạn.",
    "prom.start_date": "Ngày bắt đầu làm việc", "prom.dependents": "Số người phụ thuộc",
    "prom.start_date_note": "Dùng để xác định thời gian thử việc (không đóng bảo hiểm).",
    "prom.dependents_note": "Mỗi người phụ thuộc được giảm trừ khi tính thuế TNCN.",
    "prom.probation": "Thử việc", "prom.no_start_date": "Chưa có ngày vào làm — đang coi như đã qua thử việc",
    "audit.tax_config_saved": "Sửa cấu hình thuế", "audit.insurance_adjusted": "Điều chỉnh bảo hiểm",
    "inc.footnote": "* Cột \"Thực nhận\" đã trừ thuế & bảo hiểm. Bấm vào tháng để xem chi tiết. Tháng hiện tại là tạm tính tới hôm nay.",
    "dash.overview": "Tổng quan tháng", "dash.total_promoters": "Tổng promoter", "dash.total_sales": "Tổng doanh số",
    "dash.target_lb": "Target", "dash.avg_hit": "Hit rate trung bình", "dash.need80": "Cần ≥ 80% để hưởng thưởng",
    "dash.pending_orders": "Đơn chờ duyệt", "dash.progress_title": "Tiến độ doanh số", "dash.pending_title": "Đơn bán chờ duyệt",
    "dash.banner_size": "Kích thước ảnh gợi ý: 1200 × 400 px (tỷ lệ 3:1) — phù hợp cả PC và mobile",
    "dash.banner_title_ph": "Tiêu đề", "dash.hello": "Xin chào", "dash.group_note": "promoter trong nhóm",
    "dash.appeals_pending": "Giải trình chờ duyệt",
    "home.units": "máy", "home.exp_bonus": "Thưởng dự kiến", "home.exp_ds": "Thưởng DS dự kiến",
    "home.reached": "Đã đạt ngưỡng thưởng ✓", "home.need_more": "Cần thêm", "home.more_units": "máy nữa",
    "home.progress": "Tiến độ tháng",
    "prog.add_title": "Thêm chương trình thưởng", "prog.name": "Tên chương trình", "prog.from": "Từ ngày", "prog.to": "Đến ngày",
    "prog.sku_apply": "SKU áp dụng", "prog.selected": "đã chọn", "prog.find_name": "Tìm theo tên...",
    "prog.all_gpu": "Tất cả GPU", "prog.no_sku": "Không tìm thấy SKU phù hợp",
    "prog.per_unit": "Tiền thưởng mỗi máy (đồng)", "prog.create": "Tạo chương trình",
    "prog.running": "Chương trình đang chạy", "prog.none_running": "Không có chương trình nào đang chạy",
    "prog.ended": "Chương trình đã kết thúc",
    "prog.col_name": "Tên", "prog.col_time": "Thời gian", "prog.col_bonus": "Thưởng/máy",
    "prog.saved_target": "Đã lưu target ✓", "prog.created": "Đã tạo chương trình ✓",
    "prog.need_sku": "Vui lòng chọn ít nhất 1 SKU áp dụng",
    "rule.title": "Quy tắc thưởng cố định", "rule.col_type": "Loại", "rule.col_cond": "Điều kiện", "rule.col_amount": "Mức thưởng",
    "rule.ds1": "Thưởng DS Bậc 1", "rule.ds2": "Thưởng DS Bậc 2", "rule.ds3": "Thưởng DS Bậc 3",
    "rule.he_per": "Thưởng Highend", "rule.he_cond": "Mỗi máy HE bán ra (từ chiếc đầu)", "rule.he_amount": "Thưởng/máy cố định",
    "rule.he_over": "Thưởng Highend vượt target", "rule.he_over_cond": "Mỗi máy vượt target cá nhân", "rule.he_over_amount": "Thưởng/máy cao hơn (accelerator)",
    "rule.hint": "💡 Mức thưởng Highend cấu hình tại trang Quy tắc thưởng. Mô hình mới: thưởng theo từng máy, công bằng cho mọi shop.",
    "audit.sale_highend_changed": "Đổi cờ Highend",
    "audit.target_set":       "Set target",
    "audit.filter_all":       "Tất cả",
    "audit.filter_month":     "Lọc tháng",
    "audit.clear_month":      "✕ Bỏ lọc tháng",
    "audit.cleanup_title":    "🧹 Dọn dẹp ảnh chấm công cũ",
    "audit.cleanup_desc":     "Xoá ảnh check-in / check-out khỏi Firebase Storage và huỷ link trong Firestore. Dữ liệu chấm công (giờ, ngày) vẫn được giữ nguyên — chỉ xoá ảnh.",
    "audit.cleanup_3m":       "Cũ hơn 3 tháng",
    "audit.cleanup_6m":       "Cũ hơn 6 tháng",
    "audit.cleanup_12m":      "Cũ hơn 12 tháng",
    "audit.cleanup_btn":      "🗑 Bắt đầu dọn dẹp",
    "audit.cleanup_running":  "Đang xoá... ({done}/{total})",
    "audit.cleanup_ok":       "✅ Đã xoá ảnh của {n} bản ghi chấm công.",
    "audit.cleanup_confirm":  "Xoá ảnh attendance cũ hơn {n} tháng?\n\nHành động này không thể hoàn tác. File sẽ bị xoá khỏi Firebase Storage.",
    "audit.admin_label":      "Admin",
    "audit.supervisor_label": "Supervisor",
    "audit.notification_sent":    "Gửi thông báo",
    "audit.bonus_program_added":  "Tạo chương trình thưởng",
    "audit.attendance_checkin":   "Check-in",
    "audit.attendance_day_cleared": "Gỡ đánh dấu ngày nghỉ",
    "audit.attendance_checkout":  "Check-out",
    "audit.appeal_submitted":     "Gửi giải trình",
    "audit.appeal_approved":      "Duyệt giải trình",
    "audit.appeal_rejected":      "Từ chối giải trình",

    // ── Banner ───────────────────────────────────────────────
    "banner.manage_title":    "Quản lý Banner",
    "banner.slot":            "Slot",
    "banner.image_url":       "URL ảnh",
    "banner.link_url":        "Link khi click",
    "banner.save":            "Lưu banner",
    "banner.clear":           "Xóa",
    "banner.upload_image":    "Tải ảnh lên",
    "banner.no_banners":      "Chưa có banner nào",

    // ── Supervisor Dashboard ─────────────────────────────────
    "sv_dash.title":          "Dashboard",
    "sv_dash.subtitle":       "Tổng quan nhóm promoter",
    "sv_dash.my_group":       "Nhóm của tôi",
    "sv_dash.pending_sales":  "Sale chờ duyệt",
    "sv_dash.pending_appeals":"Giải trình chờ",
    "sv_dash.total_sales":    "Tổng sale tháng này",
    "sv_dash.promoter_list":  "Danh sách promoter",
    "sv_dash.no_promoters":   "Bạn chưa được assign promoter nào",

    // ── Promoter Home ────────────────────────────────────────
    "home.greeting":          "Xin chào,",
    "home.subtitle":          "Chào mừng bạn trở lại",
    "home.checkin_status":    "Trạng thái hôm nay",
    "home.not_checked_in":    "Chưa check-in",
    "home.checked_in":        "Đã check-in",
    "home.checked_out":       "Đã check-out",
    "home.go_checkin":        "→ Đi check-in",
    "home.this_month":        "Tháng này",
    "home.days_worked":       "Ngày đi làm",
    "home.sales_count":       "Doanh số",
    "home.pending_count":     "Chờ duyệt",
  },

  // ===========================================================
  en: {
    // ── Common ──────────────────────────────────────────────
    "common.save":            "Save changes",
    "common.saving":          "Saving...",
    "common.cancel":          "Cancel",
    "common.edit":            "Edit",
    "common.delete":          "Delete",
    "common.create":          "Create",
    "common.creating":        "Creating...",
    "common.close":           "Close",
    "common.confirm":         "Confirm",
    "common.loading":         "Loading...",
    "common.calculating":     "Calculating...",
    "common.refresh":         "Refresh",
    "common.export":          "Export Excel",
    "common.exportAll":       "⬇ Export all",
    "common.exporting":       "Exporting...",
    "common.send":            "Send",
    "common.sending":         "Sending...",
    "common.approve":         "✓ Approve",
    "common.reject":          "✕ Reject",
    "common.approve_short":   "Approve",
    "common.reject_short":    "Reject",
    "common.noData":          "No data yet",
    "common.all":             "All",
    "common.yes":             "Yes",
    "common.no":              "No",
    "common.name":            "Full name",
    "common.email":           "Email",
    "common.password":        "Password",
    "common.month":           "Month",
    "common.date":            "Date",
    "common.status":          "Status",
    "common.note":            "Note",
    "common.action":          "Action",
    "common.search":          "Search",
    "common.filter":          "Filter",
    "common.clearFilter":     "Clear filter",
    "common.total":           "Total",
    "common.detail":          "Detail",
    "common.back":            "Back",
    "common.success":         "Success",
    "common.error":           "Error",
    "common.warning":         "Warning",
    "common.recalc":          "🔄 Recalculate",
    "common.addNew":          "+ Add new",

    // ── Auth ─────────────────────────────────────────────────
    "auth.login":             "Sign in",
    "auth.logout":            "Sign out",
    "auth.logging_in":        "Signing in...",
    "auth.email":             "Email",
    "auth.password":          "Password",
    "auth.forgot":            "Forgot password?",
    "auth.back_to_login":     "← Back to sign in",
    "auth.reset_title":       "Reset password",
    "auth.reset_desc":        "Enter your account email to receive a password reset link.",
    "auth.reset_send":        "Send reset email",
    "auth.reset_sending":     "Sending...",
    "auth.reset_success":     "✅ Password reset email sent. Please check your inbox.",
    "auth.change_pw":         "Change password",
    "auth.current_pw":        "Current password",
    "auth.new_pw":            "New password",
    "auth.confirm_pw":        "Confirm new password",
    "auth.pw_min":            "Minimum 6 characters",
    "auth.pw_mismatch":       "Passwords do not match",
    "auth.pw_changed":        "✅ Password changed successfully!",
    "auth.pw_change_btn":     "Change password",
    "auth.pw_changing":       "Changing...",
    "auth.login_subtitle":    "MSI Vietnam Promoter Management",
    "auth.reset_pw_for":      "Send password reset email to",

    // ── Navigation ───────────────────────────────────────────
    "nav.dashboard":          "Dashboard",
    "nav.sales":              "Sales",
    "nav.attendance":         "Attendance",
    "nav.salary":             "Payroll",
    "nav.salary_short":       "Payroll",
    "nav.promoters":          "Promoters & Shops",
    "nav.targets":            "Targets & Bonuses",
    "nav.holidays":           "Public Holidays",
    "nav.skus":               "SKU Laptops",
    "nav.bonus_rules":        "Bonus Rules",
    "nav.notifications":      "Notifications",
    "nav.training":           "Training",
    "nav.audit":              "Audit Log",
    "nav.checkin":            "Check-in/Out",
    "nav.my_sales":           "Submit Sales",
    "nav.sku_lookup":         "SKU Lookup",
    "nav.home":               "Home",
    "nav.more":               "More",
    "nav.targets_sv":         "Set Targets",
    "nav.salary_report":      "Salary Report",
    "nav.send_notif":         "Send Notification",
    "nav.administrator":      "Administrator",
    "nav.supervisor_label":   "Supervisor",

    // ── Language ─────────────────────────────────────────────
    "lang.switch":            "Language",
    "lang.vi":                "🇻🇳 Tiếng Việt",
    "lang.en":                "🇬🇧 English",
    "lang.zh":                "🇨🇳 中文",

    // ── Dashboard ────────────────────────────────────────────
    "dash.title":             "Dashboard",
    "dash.subtitle":          "System overview",
    "dash.checkin_today":     "Checked in today",
    "dash.pending_sales":     "Sales pending review",
    "dash.pending_appeals":   "Appeals pending review",
    "dash.total_promoters":   "Total promoters",
    "dash.of_promoters":      "/ {n} promoters",
    "dash.promoters":         "promoters",
    "dash.sales_this_month":  "Sales this month",
    "dash.approved_sales":    "approved sales",
    "dash.pending_review":    "Pending",
    "dash.quick_actions":     "Quick actions",
    "dash.go_approve":        "→ Approve now",
    "dash.go_appeals":        "→ View appeals",

    // ── Sales ────────────────────────────────────────────────
    "sales.title":            "Sales",
    "sales.subtitle":         "Track progress and history",
    "sales.subtitle_sv":      "Your promoter group",
    "sales.tab_progress":     "Progress",
    "sales.tab_pending":      "Pending",
    "sales.tab_detail":       "Detail",
    "sales.tab_cancel":       "Cancel requests",
    "sales.request_cancel":   "Request cancel",
    "sales.cancel_reason":    "Cancel reason",
    "sales.approve_cancel":   "Approve cancel",
    "sales.reject_cancel":    "Reject",
    "sales.promoter":         "Promoter",
    "sales.shop":             "Shop",
    "sales.target_ds":        "Sales Target",
    "sales.sold":             "Sold",
    "sales.hit_rate":         "Hit rate",
    "sales.progress":         "Progress",
    "sales.target_he":        "HE Target",
    "sales.he_sold":          "HE sold",
    "sales.bonus_ds":         "Sales Bonus",
    "sales.bonus_he":         "HE Bonus",
    "sales.not_reached":      "Not reached",
    "sales.model":            "Model",
    "sales.serial":           "Serial",
    "sales.highend":          "Highend",
    "sales.sale_date":        "Sale date",
    "sales.submit_date":      "Submitted",
    "sales.approver":         "Approver",
    "sales.approve_all":      "Approve all",
    "sales.no_pending":       "No pending sales ✓",
    "sales.no_data_month":    "No data for this month",
    "sales.submit_title":     "Submit Sales",
    "sales.submit_subtitle":  "Record a sold laptop",
    "sales.add_sale":         "+ Add sale",
    "sales.history":          "History",
    "sales.pending_badge":    "Pending",
    "sales.approved_badge":   "Approved",
    "sales.rejected_badge":   "Rejected",
    "sales.is_highend":       "Is Highend?",
    "sales.ocr_hint":         "Take a photo of the receipt to auto-fill",
    "sales.submit_btn":       "Submit sale",
    "sales.submitting":       "Submitting...",
    "sales.no_history":       "No sales recorded yet",

    // ── Attendance ───────────────────────────────────────────
    "att.title":              "Attendance",
    "att.subtitle":           "Track and manage promoter attendance",
    "att.subtitle_sv":        "Track your group's attendance",
    "att.tab_overview":       "Overview",
    "att.tab_detail":         "Detail & Photos",
    "att.tab_appeals":        "Pending Appeals",
    "att.tab_appeals_short":  "Appeals",
    "att.checkin_today":      "Checked in today",
    "att.done_today":         "Completed shift",
    "att.checked_out":        "checked out",
    "att.not_yet":            "Not checked in",
    "att.absent_today":       "absent",
    "att.days_standard":      "Standard working days",
    "att.days_worked":        "Days worked",
    "att.holiday_days":       "Holiday days (×3)",
    "att.total_hours":        "Total hours",
    "att.26_days":            "26 days",
    "att.days":               "days",
    "att.calendar":           "Monthly calendar",
    "att.summary":            "Summary",
    "att.full":               "Full day",
    "att.partial":            "Short hours",
    "att.holiday":            "Holiday",
    "att.absent":             "Absent",
    "att.export_excel":       "⬇ Export Excel (month grid)",
    "att.leave_type":         "Leave type",
    "att.leave_paid":         "Paid leave",
    "att.leave_annual":       "Annual leave",
    "att.mark_day":           "Mark day",
    "att.mark_work":          "Full work day",
    "att.mark_work_note":     "Use when the app failed and the promoter reported via chat — this day has no photo.",
    "att.mark_clear":         "Clear mark (back to normal)",
    "att.mark_hint":          "Click to mark a leave day",
    "att.mark_overwrite":     "⚠ This day has a real attendance record — marking will delete it.",
    "att.checkin_time":       "Check-in",
    "att.checkout_time":      "Check-out",
    "att.hours":              "Hours",
    "att.photo_title":        "Attendance photos",
    "att.no_photo":           "No photo",
    "att.reason":             "Reason",
    "att.submitted_at":       "Submitted",
    "att.reject_note":        "Rejection note (optional)",
    "att.no_appeals":         "No pending appeals ✓",
    "att.appeal_title":       "Attendance appeal",
    "att.appeal_reason":      "Reason for appeal",
    "att.appeal_send":        "Submit appeal",
    "att.appeal_sending":     "Submitting...",
    "att.appeal_sent":        "Appeal submitted successfully",
    "att.appeal_limit":       "Appeal limit reached (2/month)",
    "att.approved_appeal":    "Appeal approved",
    "att.missing_checkout":   "Missing checkout",
    "att.checkin_title":      "Check-in today",
    "att.checkout_title":     "Check-out",
    "att.already_checkin":    "Already checked in today",
    "att.no_checkin":         "Not checked in today",
    "att.checkin_btn":        "📷 Take Check-in Photo",
    "att.checkout_btn":       "📷 Take Check-out Photo",
    "att.checking_in":        "Checking in...",
    "att.checking_out":       "Checking out...",
    "att.location_required":  "GPS required for check-in",
    "att.history_title":      "Monthly history",
    "att.export_single":      "⬇ Export Excel",
    "att.short":              "Short",

    // ── Salary ───────────────────────────────────────────────
    "salary.title":           "Payroll",
    "salary.subtitle":        "Monthly salary report",
    "salary.subtitle_sv":     "Group salary report (read-only)",
    "salary.base":            "Base salary",
    "salary.days_worked":     "Days worked",
    "salary.holiday_days":    "Holiday days (×3)",
    "salary.work_pay":        "Work pay",
    "salary.sales_bonus":     "Sales bonus",
    "salary.highend_bonus":   "Highend bonus",
    "salary.program_bonus":   "Program bonus",
    "salary.event_bonus":     "Event bonus",
    "salary.total":           "Total salary",
    "salary.export_csv":      "⬇ Export CSV",
    "salary.no_data":         "No data yet",
    "salary.detail_title":    "Salary breakdown",
    "salary.holiday_suffix":  " (+{n} holiday)",
    "salary.bonus_rules":     "Bonus Rules",
    "salary.bonus_rules_sub": "Configure sales & highend bonus tiers",
    "salary.reset_default":   "🔄 Reset Default",
    "salary.save_rules":      "💾 Save Rules",
    "salary.add_tier":        "+ Add Tier",
    "salary.min_rate_pct":    "Min Hit Rate (%)",
    "salary.bonus_amount":    "Bonus Amount",
    "salary.max_target_units":"Max Target Units",
    "salary.base_bonus":      "Base Bonus",
    "salary.over_bonus_per_unit": "Over Bonus/Unit",
    "salary.sales_bonus_desc":"Bonus based on sales target %",
    "salary.highend_bonus_desc": "Highend bonus by target units",
    "salary.he_unit_rate":    "Bonus per HE unit (đ)",
    "salary.he_over_rate":    "Bonus per unit over target (đ)",
    "salary.he_model_desc":   "Per-unit bonus for each HE sold + higher rate when exceeding personal target",

    // ── Promoters ────────────────────────────────────────────
    "prom.title":             "Accounts",
    "prom.subtitle":          "Manage promoters and supervisors",
    "prom.tab_promoters":     "👥 Promoters",
    "prom.tab_supervisors":   "🎖 Supervisors",
    "prom.add_promoter":      "+ Add promoter",
    "prom.add_supervisor":    "+ Add supervisor",
    "prom.create_title":      "Create new account",
    "prom.edit_title":        "Update promoter",
    "prom.create_sv_title":   "Create supervisor account",
    "prom.shop_name":         "Shop name",
    "prom.base_salary":       "Base salary (VND)",
    "prom.create_btn":        "Create account",
    "prom.save_btn":          "Save changes",
    "prom.reset_pw":          "🔑 Reset PW",
    "prom.assign":            "👥 Assign promoters",
    "prom.assign_title":      "Assign promoters →",
    "prom.assign_hint":       "Select promoters in this supervisor's group:",
    "prom.no_promoters":      "No promoters yet",
    "prom.no_supervisors":    "No supervisors yet",
    "prom.archive":           "Archive",
    "prom.restore":           "Restore",
    "prom.archived_badge":    "Archived",
    "prom.show_archived":     "Show archived",
    "prom.confirm_archive":   "This promoter will be hidden from the system. Historical data will be retained. Continue?",
    "prom.created_ok":        "Account created successfully",
    "prom.updated_ok":        "Updated successfully",
    "prom.sv_created_ok":     "Supervisor created successfully",
    "prom.reset_confirm":     "Send password reset email to",
    "prom.reset_ok":          "✅ Reset email sent to",
    "prom.assign_ok":         "Updated group for",

    // ── Targets ──────────────────────────────────────────────
    "target.title":           "Targets & Bonuses",
    "target.title_sv":        "Set Targets",
    "target.subtitle":        "Manage monthly sales targets",
    "target.subtitle_sv":     "Set monthly sales targets for promoters",
    "target.sell_target":     "Sales Target",
    "target.he_target":       "HE Target",
    "target.not_set":         "Not set",
    "target.save_ok":         "Target saved for",

    // ── Holidays ─────────────────────────────────────────────
    "holiday.title":          "Public Holidays",
    "holiday.subtitle":       "Manage national holidays",
    "holiday.add":            "+ Add holiday",
    "holiday.name":           "Holiday name",
    "holiday.date":           "Date",
    "holiday.multiplier":     "Salary multiplier",
    "holiday.no_holidays":    "No holidays added yet",
    "holiday.delete_confirm": "Delete this holiday?",

    // ── SKUs ─────────────────────────────────────────────────
    "sku.title":              "SKU Laptops",
    "sku.subtitle":           "Manage product catalog",
    "sku.subtitle_lookup":    "Look up MSI laptop specifications",
    "sku.add":                "+ Add SKU",
    "sku.model":              "Model",
    "sku.brand":              "Brand",
    "sku.cpu":                "CPU",
    "sku.gpu":                "GPU",
    "sku.ram":                "RAM",
    "sku.ssd":                "SSD",
    "sku.lcd":                "Display",
    "sku.battery":            "Battery",
    "sku.ports":              "Ports",
    "sku.upgradeable":        "Upgradeable",
    "sku.highend":            "Highend",
    "sku.no_skus":            "No SKUs added yet",
    "sku.delete_confirm":     "Delete this SKU?",
    "sku.search_placeholder": "Search by model name...",

    // ── Notifications ────────────────────────────────────────
    "notif.title":            "Notifications",
    "notif.subtitle":         "Send notifications to promoters",
    "notif.title_field":      "Title",
    "notif.body":             "Content",
    "notif.send_to":          "Send to",
    "notif.all_promoters":    "All promoters",
    "notif.all_group":        "Entire group ({n} people)",
    "notif.select_specific":  "Select specific",
    "notif.select_promoters": "Select promoters",
    "notif.attachment":       "📎 Attachment",
    "notif.send_btn":         "📢 Send notification",
    "notif.sent_ok":          "✅ Notification sent successfully!",
    "notif.no_notifs":        "No notifications",
    "notif.from_admin":       "Notifications from admin",
    "notif.empty_fields":     "Please enter a title and content.",
    "notif.select_at_least":  "Please select at least 1 promoter.",
    "notif.placeholder_title":"Notification title",
    "notif.placeholder_body": "Notification content...",
    "notif.upload_file":      "📎 Attach file (optional)",
    "notif.submit_title":     "Send Notification to Promoters",
    "notif.all_supervisors":  "All supervisors",

    // ── Bonus Rules ──────────────────────────────────────────
    "bonus.title":            "Bonus Rules",
    "bonus.subtitle":         "Configure sales and highend bonus tiers",
    "bonus.sales_tiers":      "Sales Bonus Tiers",
    "bonus.he_tiers":         "Highend Bonus Tiers",
    "bonus.programs":         "Bonus Programs",
    "bonus.min_rate":         "Minimum hit rate (%)",
    "bonus.amount":           "Bonus (VND)",
    "bonus.add_tier":         "+ Add tier",
    "bonus.program_name":     "Program name",
    "bonus.start_date":       "Start date",
    "bonus.end_date":         "End date",
    "bonus.skus_list":        "Applicable models (comma separated)",
    "bonus.per_unit":         "Bonus per unit (VND)",
    "bonus.add_program":      "+ Add program",
    "bonus.save_config":      "Save configuration",

    // ── Audit Log ────────────────────────────────────────────
    "audit.title":            "Audit Log",
    "audit.subtitle":         "History of sale approvals and target changes",
    "audit.type":             "Type",
    "audit.actor":            "Performed by",
    "audit.promoter":         "Promoter",
    "audit.detail":           "Detail",
    "audit.time":             "Time",
    "audit.sale_approved":    "Sale approved",
    "audit.sale_rejected":    "Sale rejected",
    "audit.sale_cancelled":   "Approved sale cancelled",
    "audit.income_imported":  "Historical income imported",
    // ── New modules ──
    "audit.login": "Login", "audit.logout": "Logout", "audit.password_changed": "Password changed",
    "audit.promoter_created": "Promoter created", "audit.promoter_updated": "Promoter updated",
    "audit.promoter_archived": "Promoter archived", "audit.promoter_restored": "Promoter restored",
    "audit.supervisor_created": "Supervisor created", "audit.assignment_changed": "Assignment changed",
    "audit.sale_submitted": "Sale submitted", "audit.bonus_config_saved": "Bonus rules saved",
    "audit.event_bonus_added": "Event stipend added", "audit.event_bonus_deleted": "Event stipend deleted",
    "audit.sku_added": "SKU added", "audit.sku_deleted": "SKU deleted",
    "audit.holiday_added": "Holiday added", "audit.holiday_deleted": "Holiday deleted",
    "audit.banner_saved": "Banner updated", "audit.banner_deleted": "Banner deleted",
    "audit.training_added": "Training doc added", "audit.training_updated": "Training doc updated", "audit.training_deleted": "Training doc deleted",
    "audit.sale_approval_reverted": "Approval reverted", "audit.target_approved": "Target approved",
    "audit.payroll_adjusted": "Payroll adjusted", "audit.payroll_closed": "Payroll closed", "audit.payroll_reopened": "Payroll reopened",
    "x.status": "Status", "x.month": "Month", "x.note": "Note", "x.records": "records",
    "sales.status_pending2": "⏳ Pending", "sales.status_approved2": "✓ Approved",
    "sales.status_rejected2": "✕ Rejected", "sales.status_cancelled2": "🚫 Cancelled",
    "sales.cancel_pending2": "🕓 Cancel pending", "sales.rejected_badge": "rejected",
    "sales.cancel_prompt": "Cancellation reason (e.g. customer backed out):",
    "sales.search_ph": "🔍 Search promoter / model / serial...",
    "sales.orders_unit": "orders", "sales.revert": "↩ Revert",
    "sales.revert_hint": "Revert approval — sale returns to Pending",
    "sales.revert_confirm": "Revert this approval? The sale returns to Pending.",
    "sales.dup_serial": "⚠ Serial submitted before:", "sales.dup_others": "more",
    "sales.toggle_he": "Click to toggle Highend", "sales.he_yes": "Yes ✎", "sales.he_no": "No ✎",
    "sales.locked_badge": "🔒 Closed", "sales.no_cancel_reqs": "No cancel requests",
    "sales.month_locked_view": "🔒 Payroll closed for this month — view only.",
    "sales.closing_notice": "⏳ Adding last month's sales — deadline: the 5th.",
    "sales.locked_title": "Payroll closed for this month",
    "sales.locked_sub": "View history only — no new entries.",
    "sales.current_tag": "(current)",
    "ps.mode_list": "From list", "ps.mode_search": "Search", "ps.mode_camera": "AI photo",
    "att.shift_label": "Today's shift", "att.shift_full": "Full shift ({h}h)", "att.shift_half": "Half shift ({h}h)",
    "att.shift_half_note": "Half shift counts 0.5 day; base pay reduced accordingly",
    "att.msg_compress": "📦 Compressing photo...", "att.msg_upload": "⬆ Uploading photo & getting GPS...", "att.msg_saving": "⏳ Saving...",
    "ah.pending_mode": "Pending", "ah.history_mode": "📜 History", "ah.count": "appeals",
    "ah.none": "No appeals", "ah.admin_note": "Admin note", "ah.reviewed_at": "Reviewed at",
    "ah.export": "⬇ Export CSV", "ah.st_pending": "Pending", "ah.st_approved": "Approved", "ah.st_rejected": "Rejected",
    "ah.legend_appeal": "Has appeal (hover for details)",
    "attm.title": "⚙️ Special payroll adjustments",
    "attm.leave_title": "🌴 Paid leave (manager approved)", "attm.leave_note": "Counts 1 full day without check-in",
    "attm.event_title": "🎪 Event stipend (off-hours)", "attm.event_name": "Event name", "attm.amount": "Amount", "attm.add": "+ Add",
    "train.subtitle": "Training documents & guides", "train.add_title": "➕ Add new document", "train.edit_title": "✏️ Edit document",
    "train.date": "Date", "train.title_lb": "Title", "train.content": "Content",
    "train.link": "Link (Google Drive / URL)", "train.save_change": "Save changes", "train.add_btn": "Add document",
    "train.list": "Documents", "train.none": "No training documents yet", "train.open": "📄 Open document",
    "train.need_title": "Please enter a title", "train.saved": "✅ Document saved", "train.del_confirm": "Delete this document?",
    "tga.pending_title": "🎯 Targets pending approval", "tga.proposed_by": "Proposed by",
    "tga.ds_prop": "Proposed sales", "tga.he_prop": "Proposed HE", "tga.ds_final": "Final sales", "tga.he_final": "Final HE",
    "tga.approve": "✓ Approve", "tga.adjusted": "(adjusted)",
    "tga.hint": "💡 You can edit the numbers before approving — supervisor & promoter will be notified of the final figures.",
    "tga.sv_subtitle": "Propose targets — effective after admin approval",
    "tga.wait": "⏳ Awaiting admin approval", "tga.approved": "✓ Approved", "tga.adj_note": "Admin adjusted",
    "tga.locked": "🔒 Contact admin to change", "tga.send": "Submit proposal", "tga.propose": "+ Propose",
    "pr.title": "📝 Review & close payroll",
    "pr.subtitle": "Adjust days/bonus before closing — applied everywhere salaries are shown.",
    "pr.close": "🔒 Close month", "pr.reopen": "🔓 Reopen", "pr.closed_at": "✅ Closed",
    "pr.locked_note": "— adjustments locked.", "pr.pick_promoter": "— Select promoter —",
    "pr.days_ph": "± days (e.g. 1 or -0.5)", "pr.bonus_ph": "± program bonus (₫)",
    "pr.note_ph": "Note (e.g. annual leave, bonus fix)", "pr.save": "+ Save adjustment",
    "pr.close_confirm": "Close this month's payroll? Adjustments will be locked.",
    "pr.reopen_confirm": "Reopen this month's payroll?",
    "salary.allowance": "Allowance",
    "cc.title": "💼 Total company cost (via agency)", "cc.config": "⚙ Settings",
    "cc.si": "Company social insurance", "cc.hi": "Company health insurance", "cc.ui": "Unemployment insurance",
    "cc.union": "Trade union fee", "cc.pai": "Accident insurance (PAI)",
    "cc.gross": "Total staff gross income", "cc.ins_total": "Total employer insurance & fees",
    "cc.mgmt": "Service management fee", "cc.total": "💰 TOTAL COMPANY COST",
    "cc.save_cfg": "💾 Save settings", "cc.tiers": "Management fee by headcount (₫/person/month)",
    "inc.title": "💰 Income History", "inc.m3": "3 months", "inc.m6": "6 months", "inc.m12": "12 months",
    "inc.sold": "Sold", "inc.net": "Net income", "inc.detail": "details ⓘ", "inc.provisional": "(provisional)",
    "inc.total_range": "Total", "inc.loading": "Calculating income...",
    "inc.modal_title": "Income detail", "inc.work_pay": "Work pay",
    "inc.total_income": "Total income", "inc.pretax_note": "Income before tax & insurance.",
    "inc.provisional_note": "Provisional up to today — figures may change until month end.",
    "inc.company_ins": "🏢 Company-paid insurance (not deducted)",
    "inc.emp_ins": "👤 Your insurance (deducted from salary)",
    "inc.total_company": "Company total", "inc.total_emp": "Your total",
    "inc.tax_section": "🧾 Personal income tax", "inc.taxable": "Taxable income", "inc.pit": "PIT",
    "inc.no_tax": "Income under 15,500,000₫ → no PIT due.",
    "inc.no_breakdown": "Tax/insurance details not available — admin needs to re-import the Excel file.",
    "inc.gross_lb": "Gross income",
    "x.workday": "days",
    "salary.export_xlsx": "⬇ Export Excel (full)",
    "salary.ot_nontax": "OT (non-taxable)",
    "inc.ot_exempt": "Less non-taxable OT",
    "cc.usd_rate": "USD rate (₫)",
    "pr.ot_ph": "± non-taxable OT (₫)",
    "sales.locked_approve_warn": "Month {month} is past the closing date. Approving this cancellation will reduce that month's sales and bonus — the salary figures already settled will change. Continue?",
    "sales.locked_hint": "Month is closed — only an admin can approve the cancellation. You can still reject the request.",
    "audit.sale_cancel_rejected": "Cancellation rejected",
    "sku.clear_filters": "Clear filters",
    "cfg.ot_tiers": "Three overtime tiers (Labour Code Art. 98)",
    "cfg.ot_tiers_note": "% of hourly rate, paid only when requested in advance and approved (if approval is on).",
    "cfg.weekly_off_ot": "Working the weekly rest day",
    "cfg.weekly_off_ot_hint": "Legal minimum 200%. The day does not count as a regular day.",
    "cfg.edit_in_ot_tab": "(edit in the Hours & overtime tab)",
    "ot.kind": "Overtime type",
    "ot.kind_extra": "Extra hours",
    "ot.kind_weekly_off": "Weekly rest day",
    "ot.note_weekly_off": "Working your weekly rest day: paid by hours worked (up to the hours requested) at the rest-day rate, not as a regular day.",
    "pay.weekly_off": "Rest-day work",
    "cfg.rate_hours": "Hours used for the hourly rate",
    "cfg.rate_hours_hint": "Hourly rate = base ÷ standard days ÷ these hours (the agency uses 8)",
    "ot.kind_holiday": "Holiday work",
    "ot.note_holiday": "Holiday: every hour worked is paid at the holiday rate, but must be requested in advance and approved — unrequested hours are not paid. Enter the total hours you will work (including beyond the shift).",
    "ot.admin_title": "Overtime / holiday hours (admin entry)",
    "ot.admin_current": "Current: {kind} {h}h",
    "ot.by_admin": "entered by admin",
    "ot.hours_unit": "hours",
    "ot.admin_note_ph": "Note (e.g. per agency payroll)",
    "ot.admin_hint_holiday": "Total hours worked on the holiday — all paid at the holiday rate. Admin-entered hours are used exactly as entered.",
    "ot.admin_hint_weekly_off": "Total hours worked on the weekly rest day — paid at the rest-day rate; the day is not a regular day.",
    "ot.admin_hint_extra": "Hours beyond the standard shift — paid at the weekday overtime rate.",
    "ot.admin_save": "Save (approved)",
    "ot.admin_update": "Update",
    "ot.admin_delete": "Delete",
    "ot.admin_hours_err": "Hours must be above 0 and at most 24",
    "inc.probation_flat_note": "On probation — not yet enrolled in insurance; tax is withheld at {pct}% of total income (overtime included), no family deduction.",
    "tax.probation_mode": "Tax during probation",
    "tax.probation_flat": "Flat % of total income",
    "tax.probation_prog": "Progressive, no family deduction",
    "tax.probation_flat_hint": "What the agency does: % × total gross (overtime included), no deductions.",
    "tax.probation_prog_hint": "Progressive brackets like permanent staff, but without family deductions.",
    "tax.probation_rate": "Probation withholding rate",
    "tax.probation_min": "No withholding below",
    "nav.bonus_programs": "Bonus programs",
    "prog.created_notified": "Program created and all promoters & supervisors notified ✓",
    "bp.title": "Bonus programs",
    "bp.sub_promoter": "Per-model bonus programs — your units sold and estimated bonus",
    "bp.sub_supervisor": "Per-model bonus programs — units sold by your team",
    "bp.running": "Running",
    "bp.upcoming": "Upcoming",
    "bp.history": "Ended",
    "bp.none_running": "No program is running right now",
    "bp.none_ended": "No program has ended yet",
    "bp.st_running": "Running",
    "bp.st_upcoming": "Upcoming",
    "bp.st_ended": "Ended",
    "bp.days_left": "{n} days left",
    "bp.last_day": "last day",
    "bp.starts_in": "starts in {n} days",
    "bp.per_unit": "Bonus per unit",
    "bp.my_units": "You sold",
    "bp.my_bonus": "Estimated bonus",
    "bp.team_units": "Your team ({team} promoters) sold: {n} units",
    "bp.models": "Applies to {n} models",
    "bp.more": "+{n} models",
    "bp.less": "Show less",
    "bp.view": "View program",
    "bp.note": "Only approved sales of listed models sold within the program period count. Final amounts follow the monthly payroll.",
    "prog.edit": "Edit",
    "prog.revoke": "Revoke",
    "prog.restore": "Restore",
    "prog.edit_title": "Edit program: {name}",
    "prog.edit_note": "Saving notifies all promoters & supervisors with what changed. Payroll bonuses are recalculated with the new details.",
    "prog.save_edit": "Save changes & notify",
    "prog.bad_dates": "End date must be on or after the start date",
    "prog.updated_notified": "Program updated and all promoters & supervisors notified ✓",
    "prog.revoke_prompt": "Revoke program \"{name}\"?\n\nAfter revoking, the program pays NO bonus for any sale (including sales already made). To stop it early instead, press Cancel and edit the end date.\n\nReason (sent with the notification, optional):",
    "prog.revoked_notified": "Program revoked and everyone notified ✓",
    "prog.restore_confirm": "Re-apply program \"{name}\"? Bonuses will be counted again and everyone will be notified.",
    "prog.restored_notified": "Program restored and everyone notified ✓",
    "prog.revoked_title": "Revoked programs",
    "prog.reason": "Reason",
    "prog.closed_warn": "Payroll for {months} is already closed. This change will alter bonuses in the closed payroll. Continue?",
    "bp.st_revoked": "Revoked",
    "bp.revoked_note": "This program was revoked and no longer pays a bonus",
    "bp.updated_at": "Updated {d}",
    "skm.upload": "Upload master file",
    "skm.busy": "Working...",
    "skm.panel_title": "Upload MSI spec master",
    "skm.reading": "Reading {name}...",
    "skm.no_products": "No SKU (Part No starting with 9S7-) found in the file",
    "skm.found": "Sheet {sheet}: {n} SKUs, {cols} spec columns. Review, then press Confirm.",
    "skm.k_new": "new",
    "skm.k_changed": "changed",
    "skm.k_back": "back on sale",
    "skm.k_same": "unchanged",
    "skm.k_leaving": "discontinued",
    "skm.leaving_note": "SKUs no longer in the master will be marked \"Discontinued\": hidden from promoter lookup; past sales and programs stay intact.",
    "skm.skipped": "Skipped {n} rows whose Part No does not start with 9S7-",
    "skm.keep_note": "Highend flags and admin notes on existing SKUs are kept. New SKUs get Highend automatically from the GPU.",
    "skm.confirm": "Confirm {n} SKUs",
    "skm.applying": "Saving...",
    "skm.done": "Done: +{added} new, ↺ {updated} updated, ⛔ {disc} discontinued.",
    "skm.current": "Current master: {name} · {n} SKUs · {d}",
    "skm.none": "No spec master uploaded yet",
    "skm.st_active": "On sale",
    "skm.st_disc": "Discontinued",
    "skm.st_all": "All SKUs",
    "skm.master_cols": "Master columns",
    "skm.empty": "No SKUs yet. Press \"📤 Upload master file\".",
    "skm.remap_confirm": "Refresh the SKU table columns with the new configuration, using the stored master specs (no re-upload needed)?",
    "skm.remapped": "Updated {n} SKUs with the new configuration.",
    "spec.msi_standard": "MSI standard specs",
    "spec.show_all": "View all specs",
    "spec.hide_all": "Collapse",
    "spec.no_master": "This SKU is not in the spec master yet — showing basic info.",
    "nav.reports": "Sales reports",
    "rpt.title": "Sales reports",
    "rpt.subtitle": "Overview by promoter, model and segment across months — against targets",
    "rpt.from": "From",
    "rpt.to": "To",
    "rpt.last_n": "{n} months",
    "rpt.all_promoters": "All promoters",
    "rpt.units": "Units sold",
    "rpt.months": "months",
    "rpt.vs_target": "Target achieved",
    "rpt.highend": "Highend units",
    "rpt.active_promoters": "Promoters with data",
    "rpt.trend": "Sales by month",
    "rpt.sold": "Sold",
    "rpt.tab_promoter": "By promoter",
    "rpt.tab_model": "By model",
    "rpt.tab_mix": "Segment mix",
    "rpt.promoter_hint": "Each cell: units sold / target, % achieved and Highend. Click a promoter for month-by-month detail.",
    "rpt.total": "Total",
    "rpt.hit": "achieved",
    "rpt.near": "close",
    "rpt.miss": "missed",
    "rpt.imported": "imported",
    "rpt.imported_note": "Italic: older months use imported figures (no model detail).",
    "rpt.model_search": "Search model or segment...",
    "rpt.segment": "Segment",
    "rpt.no_sales": "No approved sales in this range",
    "rpt.model_note": "Approved sales entered in the app only. Promoter column: how many promoters sold the model.",
    "rpt.classify_by": "Classify by",
    "rpt.by_segment": "Product line (Segment)",
    "rpt.by_series": "Group (Gaming / Business)",
    "rpt.whole_range": "Whole selected range",
    "rpt.mix": "Mix",
    "rpt.mix_note": "Segments come from SKU specs (master file). Models not matching any SKU are \"Unclassified\"; small segments are grouped as \"Other\".",
    "rpt.unknown": "Unclassified",
    "rpt.other": "Other",
    "rpt.top_models": "Top models",
    "prom.salary_from": "New salary applies from month",
    "prom.salary_from_note": "Months before this keep the old amount ({old} ₫). This month and later use the new amount.",
    "prom.salary_saved": "New salary saved, applies from {month}",
    "prom.salary_history": "Base salary history",
    "prom.salary_initial": "Initial",
    "prom.salary_from_m": "from {m}",
    "prom.salary_past_warn": "Applying back from {month}: payroll for past months (including closed ones) will be recalculated with the new amount. Continue?",
    "nav.settings": "Settings",
    "cfg.title": "Settings",
    "cfg.subtitle": "Every rule for attendance, pay, tax and cost — in one place",
    "cfg.tab_work": "Hours & overtime",
    "cfg.tab_holiday": "Holidays & paid days off",
    "cfg.tab_bonus": "Bonuses",
    "cfg.tab_tax": "Tax & insurance",
    "cfg.tab_cost": "Agency cost",
    "cfg.tab_rules": "Other rules",
    "cfg.effective_from": "Effective from",
    "cfg.editing_existing": "Editing the version effective from {month}. Saving overwrites it.",
    "cfg.creating_new": "No version for {month} yet — saving creates one effective from {month} onward. Earlier months keep their rules.",
    "cfg.save": "Save, effective {month}",
    "cfg.saved": "Saved. New rules apply from {month}.",
    "cfg.past_warn": "{month} is in the past. Saving will change pay for {month} and later months. Continue?",
    "cfg.delete_confirm": "Delete the version effective from {month}? Those months revert to the previous version.",
    "cfg.history": "Change history",
    "cfg.no_versions": "No versions yet — every month uses the original rules.",
    "cfg.from": "From",
    "cfg.legacy_note": "Months before the first version use the original rules (8h shift, holiday ×3, no overtime) so settled pay still matches.",
    "cfg.standard_days": "Standard days / month",
    "cfg.standard_days_hint": "Daily rate = base salary ÷ this",
    "cfg.standard_hours": "Standard hours / day",
    "cfg.standard_hours_hint": "Meeting this is a full day; only time beyond it can be overtime",
    "cfg.half_shift": "Half-shift hours",
    "cfg.half_shift_hint": "A half shift counts as 0.5 day",
    "cfg.tolerance": "Short-hours tolerance",
    "cfg.tolerance_hint": "Up to this many hours short still counts as a full day (0 = exact)",
    "cfg.ot_rate": "Weekday overtime",
    "cfg.ot_rate_hint": "% of hourly rate — legal minimum 150%",
    "cfg.ot_approval": "Overtime requests must be approved before they are paid",
    "cfg.ot_tax_exempt": "Overtime and holiday-work pay are PIT-exempt (PIT Law 2025)",
    "cfg.example_work": "Base 6,500,000₫ → daily {daily}₫, hourly {hourly}₫ (÷ {h}h), 1h overtime = {ot}₫",
    "cfg.holiday_paid": "Holiday pay",
    "cfg.holiday_paid_hint": "% of daily rate — paid whether or not they work",
    "cfg.holiday_ot": "Holidays, Tết, paid days off",
    "cfg.holiday_ot_hint": "% of hourly rate, for every requested holiday hour — legal minimum 300%, on top of holiday pay",
    "cfg.example_holiday": "Holiday off: {off}% of daily rate · Holiday worked: {on}% of daily rate",
    "cfg.holiday_list_note": "The holiday list takes effect immediately and is not versioned.",
    "cfg.people": "people",
    "cfg.person": "person",
    "cfg.closing_day": "Closing day",
    "cfg.closing_day_hint": "Last month stays editable until the end of this day",
    "cfg.max_appeals": "Max approved appeals / month",
    "cfg.max_appeals_hint": "Per promoter",
    "cfg.remind_hour": "Check-out reminder hour",
    "cfg.remind_hour_hint": "Notify promoters who haven't checked out",
    "ot.title": "Request overtime",
    "ot.hours": "Overtime hours",
    "ot.note": "Only time beyond {h} hours counts, up to the hours requested.",
    "ot.reason_ph": "e.g. promotion event, stock count…",
    "ot.submit": "Submit request",
    "ot.registered": "Overtime requested: {h}h",
    "ot.st_pending": "pending",
    "ot.st_approved": "approved",
    "ot.withdraw": "Withdraw",
    "ot.pending_title": "Overtime requests pending",
    "pay.incl_holiday": "incl. {n} holiday(s)",
    "pay.holiday_pay": "Holiday pay",
    "pay.holiday_ot": "Holiday work",
    "pay.ot": "Overtime",
    "audit.payroll_config_saved": "Settings saved",
    "audit.payroll_config_deleted": "Settings version deleted",
    "audit.ot_requested": "Overtime requested",
    "audit.ot_approved": "Overtime approved",
    "audit.ot_rejected": "Overtime rejected",
    "audit.ot_withdrawn": "Overtime withdrawn",
    "att.st_full": "Full day",
    "att.st_missing": "Missing punch",
    "att.st_short": "Short hours",
    "att.st_holiday": "Holiday",
    "att.st_annualLeave": "Annual leave",
    "att.st_unpaidLeave": "Unpaid leave",
    "att.st_weeklyOff": "Weekly rest",
    "att.st_future": "Upcoming",
    "lv.title": "Request leave",
    "lv.type": "Leave type",
    "lv.unpaid": "Unpaid leave",
    "lv.annual_note": "Deducted from annual leave; still counts as a full day.",
    "lv.unpaid_note": "No day credit and no pay for that day.",
    "lv.reason": "Reason",
    "lv.reason_ph": "e.g. family matter, medical appointment...",
    "lv.approval_note": "The request goes to your manager. The leave only applies once approved.",
    "lv.submit": "Submit",
    "lv.book_hint": "Tap a future day to request leave",
    "lv.pending_hint": "Leave request awaiting approval",
    "lv.pending_short": "Pending",
    "lv.pending_title": "Leave requests pending",
    "lv.approve": "Approve",
    "lv.reject": "Reject",
    "audit.leave_requested": "Leave requested",
    "audit.leave_approved": "Leave approved",
    "audit.leave_rejected": "Leave rejected",
    "inc.probation_note": "On probation — not yet enrolled in insurance, and no family deduction applies.",
    "inc.meal_exempt": "Less tax-exempt meal allowance",
    "inc.personal_ded": "Personal deduction",
    "inc.dependent_ded": "Dependent deduction",
    "inc.taxable_base": "Assessable income",
    "cc.ins_base": "Insured salary", "cc.insured": "Insured",
    "cc.show_detail": "▸ Per-person detail", "cc.hide_detail": "▾ Collapse",
    "cc.detail_note": "Click a salary cell to override it for this month · Untick to exclude from insurance",
    "cc.export_detail": "⬇ Export CSV",
    "cc.probation_until": "Probation until",
    "cc.under14_note": "Under 14 credited days this month — law allows skipping insurance",
    "tax.title": "🧾 PIT & insurance settings",
    "tax.legal_note": "PIT Law 2025 (109/2025/QH15) · Resolution 110/2025 · Decree 253/2026",
    "tax.personal_ded": "Personal deduction (₫/month)",
    "tax.dependent_ded": "Dependent deduction (₫/month)",
    "tax.meal_cap": "Tax-exempt meal cap (₫/month)",
    "tax.probation_months": "Probation length (months)",
    "tax.emp_si": "Employee SI (%)", "tax.emp_hi": "Employee HI (%)", "tax.emp_ui": "Employee UI (%)",
    "tax.emp_total": "Employee pays", "tax.brackets": "Progressive brackets", "tax.tier": "Tier",
    "tax.up_to": "Up to (₫/month)", "tax.tiers_count": "brackets",
    "tax.up_to_note": "Leave \"Up to\" empty on the last tier = no upper limit.",
    "prom.start_date": "Start date", "prom.dependents": "Dependents",
    "prom.start_date_note": "Used to determine the probation period (no insurance).",
    "prom.dependents_note": "Each dependent gives a PIT deduction.",
    "prom.probation": "Probation", "prom.no_start_date": "No start date — treated as past probation",
    "audit.tax_config_saved": "Tax settings changed", "audit.insurance_adjusted": "Insurance adjusted",
    "inc.footnote": "* \"Net income\" is after tax & insurance. Click a month for details. Current month is provisional.",
    "dash.overview": "Overview — month", "dash.total_promoters": "Total promoters", "dash.total_sales": "Total sales",
    "dash.target_lb": "Target", "dash.avg_hit": "Average hit rate", "dash.need80": "≥ 80% required for bonus",
    "dash.pending_orders": "Pending orders", "dash.progress_title": "Sales progress", "dash.pending_title": "Pending sales",
    "dash.banner_size": "Suggested image size: 1200 × 400 px (3:1) — fits PC & mobile",
    "dash.banner_title_ph": "Title", "dash.hello": "Hello", "dash.group_note": "promoters in your group",
    "dash.appeals_pending": "Appeals pending",
    "home.units": "units", "home.exp_bonus": "Expected bonus", "home.exp_ds": "Expected sales bonus",
    "home.reached": "Bonus threshold reached ✓", "home.need_more": "Need", "home.more_units": "more units",
    "home.progress": "Progress — month",
    "prog.add_title": "Add bonus program", "prog.name": "Program name", "prog.from": "From", "prog.to": "To",
    "prog.sku_apply": "Applicable SKUs", "prog.selected": "selected", "prog.find_name": "Search by name...",
    "prog.all_gpu": "All GPUs", "prog.no_sku": "No matching SKU",
    "prog.per_unit": "Bonus per unit (₫)", "prog.create": "Create program",
    "prog.running": "Running programs", "prog.none_running": "No running programs",
    "prog.ended": "Ended programs",
    "prog.col_name": "Name", "prog.col_time": "Period", "prog.col_bonus": "Bonus/unit",
    "prog.saved_target": "Target saved ✓", "prog.created": "Program created ✓",
    "prog.need_sku": "Please select at least 1 SKU",
    "rule.title": "Fixed bonus rules", "rule.col_type": "Type", "rule.col_cond": "Condition", "rule.col_amount": "Amount",
    "rule.ds1": "Sales bonus — Tier 1", "rule.ds2": "Sales bonus — Tier 2", "rule.ds3": "Sales bonus — Tier 3",
    "rule.he_per": "Highend bonus", "rule.he_cond": "Each HE unit sold (from the first)", "rule.he_amount": "Fixed bonus per unit",
    "rule.he_over": "Highend over-target bonus", "rule.he_over_cond": "Each unit over personal target", "rule.he_over_amount": "Higher rate per unit (accelerator)",
    "rule.hint": "💡 Highend rates are configured on the Bonus Rules page. Per-unit model — fair for every shop.",
    "audit.sale_highend_changed": "Highend flag changed",
    "audit.target_set":       "Target set",
    "audit.filter_all":       "All",
    "audit.filter_month":     "Filter month",
    "audit.clear_month":      "✕ Clear filter",
    "audit.cleanup_title":    "🧹 Clean up old attendance photos",
    "audit.cleanup_desc":     "Delete check-in/check-out photos from Firebase Storage and clear URLs in Firestore. Attendance data (hours, dates) is preserved — only photos are deleted.",
    "audit.cleanup_3m":       "Older than 3 months",
    "audit.cleanup_6m":       "Older than 6 months",
    "audit.cleanup_12m":      "Older than 12 months",
    "audit.cleanup_btn":      "🗑 Start cleanup",
    "audit.cleanup_running":  "Deleting... ({done}/{total})",
    "audit.cleanup_ok":       "✅ Deleted photos from {n} attendance records.",
    "audit.cleanup_confirm":  "Delete photos older than {n} months?\n\nThis action cannot be undone. Files will be permanently deleted from Firebase Storage.",
    "audit.admin_label":      "Admin",
    "audit.supervisor_label": "Supervisor",
    "audit.notification_sent":    "Notification sent",
    "audit.bonus_program_added":  "Bonus program created",
    "audit.attendance_checkin":   "Check-in",
    "audit.attendance_day_cleared": "Leave mark removed",
    "audit.attendance_checkout":  "Check-out",
    "audit.appeal_submitted":     "Appeal submitted",
    "audit.appeal_approved":      "Appeal approved",
    "audit.appeal_rejected":      "Appeal rejected",

    // ── Banner ───────────────────────────────────────────────
    "banner.manage_title":    "Manage Banners",
    "banner.slot":            "Slot",
    "banner.image_url":       "Image URL",
    "banner.link_url":        "Click link",
    "banner.save":            "Save banner",
    "banner.clear":           "Clear",
    "banner.upload_image":    "Upload image",
    "banner.no_banners":      "No banners yet",

    // ── Supervisor Dashboard ─────────────────────────────────
    "sv_dash.title":          "Dashboard",
    "sv_dash.subtitle":       "Your promoter group overview",
    "sv_dash.my_group":       "My group",
    "sv_dash.pending_sales":  "Sales pending",
    "sv_dash.pending_appeals":"Appeals pending",
    "sv_dash.total_sales":    "Total sales this month",
    "sv_dash.promoter_list":  "Promoter list",
    "sv_dash.no_promoters":   "No promoters assigned to you yet",

    // ── Promoter Home ────────────────────────────────────────
    "home.greeting":          "Hello,",
    "home.subtitle":          "Welcome back",
    "home.checkin_status":    "Today's status",
    "home.not_checked_in":    "Not checked in",
    "home.checked_in":        "Checked in",
    "home.checked_out":       "Checked out",
    "home.go_checkin":        "→ Go check-in",
    "home.this_month":        "This month",
    "home.days_worked":       "Days worked",
    "home.sales_count":       "Sales",
    "home.pending_count":     "Pending",
  },

  // ===========================================================
  zh: {
    // ── Common ──────────────────────────────────────────────
    "common.save":            "儲存變更",
    "common.saving":          "儲存中...",
    "common.cancel":          "取消",
    "common.edit":            "編輯",
    "common.delete":          "刪除",
    "common.create":          "建立",
    "common.creating":        "建立中...",
    "common.close":           "關閉",
    "common.confirm":         "確認",
    "common.loading":         "載入中...",
    "common.calculating":     "計算中...",
    "common.refresh":         "重新整理",
    "common.export":          "匯出Excel",
    "common.exportAll":       "⬇ 匯出全部",
    "common.exporting":       "匯出中...",
    "common.send":            "傳送",
    "common.sending":         "傳送中...",
    "common.approve":         "✓ 審核",
    "common.reject":          "✕ 拒絕",
    "common.approve_short":   "審核",
    "common.reject_short":    "拒絕",
    "common.noData":          "暫無資料",
    "common.all":             "全部",
    "common.yes":             "是",
    "common.no":              "否",
    "common.name":            "姓名",
    "common.email":           "電子郵件",
    "common.password":        "密碼",
    "common.month":           "月份",
    "common.date":            "日期",
    "common.status":          "狀態",
    "common.note":            "備註",
    "common.action":          "操作",
    "common.search":          "搜尋",
    "common.filter":          "篩選",
    "common.clearFilter":     "清除篩選",
    "common.total":           "合計",
    "common.detail":          "詳情",
    "common.back":            "返回",
    "common.success":         "成功",
    "common.error":           "錯誤",
    "common.warning":         "警告",
    "common.recalc":          "🔄 重新計算",
    "common.addNew":          "+ 新增",

    // ── Auth ─────────────────────────────────────────────────
    "auth.login":             "登入",
    "auth.logout":            "登出",
    "auth.logging_in":        "登入中...",
    "auth.email":             "電子郵件",
    "auth.password":          "密碼",
    "auth.forgot":            "忘記密碼？",
    "auth.back_to_login":     "← 返回登入",
    "auth.reset_title":       "重設密碼",
    "auth.reset_desc":        "輸入您的帳戶電子郵件以接收密碼重設連結。",
    "auth.reset_send":        "傳送重設郵件",
    "auth.reset_sending":     "傳送中...",
    "auth.reset_success":     "✅ 密碼重設郵件已傳送，請查收信箱。",
    "auth.change_pw":         "變更密碼",
    "auth.current_pw":        "目前密碼",
    "auth.new_pw":            "新密碼",
    "auth.confirm_pw":        "確認新密碼",
    "auth.pw_min":            "至少6個字元",
    "auth.pw_mismatch":       "兩次密碼不一致",
    "auth.pw_changed":        "✅ 密碼變更成功！",
    "auth.pw_change_btn":     "變更密碼",
    "auth.pw_changing":       "變更中...",
    "auth.login_subtitle":    "MSI越南促銷員管理系統",
    "auth.reset_pw_for":      "傳送密碼重設郵件至",

    // ── Navigation ───────────────────────────────────────────
    "nav.dashboard":          "儀表板",
    "nav.sales":              "銷售",
    "nav.attendance":         "出勤",
    "nav.salary":             "薪資",
    "nav.salary_short":       "薪資",
    "nav.promoters":          "促銷員管理",
    "nav.targets":            "目標與獎金",
    "nav.holidays":           "國定假日",
    "nav.skus":               "SKU產品",
    "nav.bonus_rules":        "獎金規則",
    "nav.notifications":      "通知",
    "nav.training":           "培訓資料",
    "nav.audit":              "操作記錄",
    "nav.checkin":            "打卡",
    "nav.my_sales":           "登錄銷售",
    "nav.sku_lookup":         "SKU查詢",
    "nav.home":               "首頁",
    "nav.more":               "更多",
    "nav.targets_sv":         "設定目標",
    "nav.salary_report":      "薪資報告",
    "nav.send_notif":         "傳送通知",
    "nav.administrator":      "管理員",
    "nav.supervisor_label":   "主管",

    // ── Language ─────────────────────────────────────────────
    "lang.switch":            "語言",
    "lang.vi":                "🇻🇳 Tiếng Việt",
    "lang.en":                "🇬🇧 English",
    "lang.zh":                "🇹🇼 繁體中文",

    // ── Dashboard ────────────────────────────────────────────
    "dash.title":             "儀表板",
    "dash.subtitle":          "系統概覽",
    "dash.checkin_today":     "今日已打卡",
    "dash.pending_sales":     "待審核銷售",
    "dash.pending_appeals":   "待審核申訴",
    "dash.total_promoters":   "促銷員總數",
    "dash.of_promoters":      "/ {n} 人",
    "dash.promoters":         "人",
    "dash.sales_this_month":  "本月銷售",
    "dash.approved_sales":    "已審核",
    "dash.pending_review":    "待處理",
    "dash.quick_actions":     "快速操作",
    "dash.go_approve":        "→ 立即審核",
    "dash.go_appeals":        "→ 查看申訴",

    // ── Sales ────────────────────────────────────────────────
    "sales.title":            "銷售",
    "sales.subtitle":         "追蹤進度和歷史記錄",
    "sales.subtitle_sv":      "您的促銷員團隊",
    "sales.tab_progress":     "進度",
    "sales.tab_pending":      "待審核",
    "sales.tab_detail":       "詳情",
    "sales.tab_cancel":       "取消請求",
    "sales.request_cancel":   "請求取消",
    "sales.cancel_reason":    "取消原因",
    "sales.approve_cancel":   "批准取消",
    "sales.reject_cancel":    "拒絕",
    "sales.promoter":         "促銷員",
    "sales.shop":             "門市",
    "sales.target_ds":        "銷售目標",
    "sales.sold":             "已售",
    "sales.hit_rate":         "達成率",
    "sales.progress":         "進度",
    "sales.target_he":        "高端目標",
    "sales.he_sold":          "高端已售",
    "sales.bonus_ds":         "銷售獎金",
    "sales.bonus_he":         "高端獎金",
    "sales.not_reached":      "未達標",
    "sales.model":            "型號",
    "sales.serial":           "序號",
    "sales.highend":          "高端",
    "sales.sale_date":        "銷售日期",
    "sales.submit_date":      "提交時間",
    "sales.approver":         "審核人",
    "sales.approve_all":      "全部核准",
    "sales.no_pending":       "沒有待審核銷售 ✓",
    "sales.no_data_month":    "本月暫無資料",
    "sales.submit_title":     "登錄銷售",
    "sales.submit_subtitle":  "記錄已售筆記型電腦",
    "sales.add_sale":         "+ 新增銷售",
    "sales.history":          "歷史記錄",
    "sales.pending_badge":    "待審核",
    "sales.approved_badge":   "已審核",
    "sales.rejected_badge":   "已拒絕",
    "sales.is_highend":       "是否高端型號？",
    "sales.ocr_hint":         "拍攝收據照片自動填寫",
    "sales.submit_btn":       "提交銷售",
    "sales.submitting":       "提交中...",
    "sales.no_history":       "暫無銷售記錄",

    // ── Attendance ───────────────────────────────────────────
    "att.title":              "出勤",
    "att.subtitle":           "追蹤和管理促銷員出勤",
    "att.subtitle_sv":        "追蹤團隊出勤狀況",
    "att.tab_overview":       "總覽",
    "att.tab_detail":         "詳情與照片",
    "att.tab_appeals":        "待審核申訴",
    "att.tab_appeals_short":  "申訴",
    "att.checkin_today":      "今日已打卡",
    "att.done_today":         "已完成班次",
    "att.checked_out":        "已打下班卡",
    "att.not_yet":            "未打卡",
    "att.absent_today":       "缺勤",
    "att.days_standard":      "標準工作天數",
    "att.days_worked":        "出勤天數",
    "att.holiday_days":       "國定假日（×3）",
    "att.total_hours":        "總工時",
    "att.26_days":            "26天",
    "att.days":               "天",
    "att.calendar":           "月度行事曆",
    "att.summary":            "彙總",
    "att.full":               "全勤",
    "att.partial":            "工時不足",
    "att.holiday":            "國定假日",
    "att.absent":             "缺勤",
    "att.export_excel":       "⬇ 匯出Excel（月度表）",
    "att.leave_type":         "休假類型",
    "att.leave_paid":         "帶薪休假",
    "att.leave_annual":       "年假",
    "att.mark_day":           "標記日期",
    "att.mark_work":          "全勤日",
    "att.mark_work_note":     "應用程式故障、促銷員已透過聊天回報時使用 — 該日無打卡照片。",
    "att.mark_clear":         "取消標記（恢復正常）",
    "att.mark_hint":          "點擊以標記休假日",
    "att.mark_overwrite":     "⚠ 此日已有實際打卡記錄 — 標記將刪除該記錄。",
    "att.checkin_time":       "上班打卡",
    "att.checkout_time":      "下班打卡",
    "att.hours":              "工時",
    "att.photo_title":        "出勤照片",
    "att.no_photo":           "無照片",
    "att.reason":             "原因",
    "att.submitted_at":       "提交時間",
    "att.reject_note":        "拒絕備註（選填）",
    "att.no_appeals":         "沒有待處理申訴 ✓",
    "att.appeal_title":       "出勤申訴",
    "att.appeal_reason":      "申訴原因",
    "att.appeal_send":        "提交申訴",
    "att.appeal_sending":     "提交中...",
    "att.appeal_sent":        "申訴提交成功",
    "att.appeal_limit":       "本月申訴次數已用完（2次）",
    "att.approved_appeal":    "申訴已核准",
    "att.missing_checkout":   "未打下班卡",
    "att.checkin_title":      "今日上班打卡",
    "att.checkout_title":     "下班打卡",
    "att.already_checkin":    "今日已打卡",
    "att.no_checkin":         "今日未打上班卡",
    "att.checkin_btn":        "📷 拍照打卡",
    "att.checkout_btn":       "📷 拍照下班",
    "att.checking_in":        "打卡中...",
    "att.checking_out":       "下班打卡中...",
    "att.location_required":  "打卡需要開啟GPS定位",
    "att.history_title":      "月度記錄",
    "att.export_single":      "⬇ 匯出Excel",
    "att.short":              "不足",

    // ── Salary ───────────────────────────────────────────────
    "salary.title":           "薪資",
    "salary.subtitle":        "月度薪資報告",
    "salary.subtitle_sv":     "團隊薪資報告（唯讀）",
    "salary.base":            "基本薪資",
    "salary.days_worked":     "出勤天數",
    "salary.holiday_days":    "國定假日（×3）",
    "salary.work_pay":        "出勤薪資",
    "salary.sales_bonus":     "銷售獎金",
    "salary.highend_bonus":   "高端獎金",
    "salary.program_bonus":   "活動獎金",
    "salary.event_bonus":     "活動津貼",
    "salary.total":           "總薪資",
    "salary.export_csv":      "⬇ 匯出CSV",
    "salary.no_data":         "暫無資料",
    "salary.detail_title":    "薪資明細",
    "salary.holiday_suffix":  "（+{n}假日）",
    "salary.bonus_rules":     "獎金規則",
    "salary.bonus_rules_sub": "配置銷售和高端獎金等級",
    "salary.reset_default":   "🔄 重置默認",
    "salary.save_rules":      "💾 保存規則",
    "salary.add_tier":        "+ 添加等級",
    "salary.min_rate_pct":    "最低達成率 (%)",
    "salary.bonus_amount":    "獎金金額",
    "salary.max_target_units":"最大目標數量",
    "salary.base_bonus":      "基礎獎金",
    "salary.over_bonus_per_unit": "超額獎金/台",
    "salary.sales_bonus_desc":"根據銷售目標完成率獎金",
    "salary.highend_bonus_desc": "根據目標數量的高端獎金",
    "salary.he_unit_rate":    "每台高端獎金 (đ)",
    "salary.he_over_rate":    "超過目標每台獎金 (đ)",
    "salary.he_model_desc":   "每售出一台高端機均有獎金 + 超過個人目標時獎金更高",

    // ── Promoters ────────────────────────────────────────────
    "prom.title":             "帳號管理",
    "prom.subtitle":          "管理促銷員和主管",
    "prom.tab_promoters":     "👥 促銷員",
    "prom.tab_supervisors":   "🎖 主管",
    "prom.add_promoter":      "+ 新增促銷員",
    "prom.add_supervisor":    "+ 新增主管",
    "prom.create_title":      "建立新帳號",
    "prom.edit_title":        "更新促銷員",
    "prom.create_sv_title":   "建立主管帳號",
    "prom.shop_name":         "門市名稱",
    "prom.base_salary":       "基本薪資（越盾）",
    "prom.create_btn":        "建立帳號",
    "prom.save_btn":          "儲存變更",
    "prom.reset_pw":          "🔑 重設密碼",
    "prom.assign":            "👥 分配促銷員",
    "prom.assign_title":      "分配促銷員 →",
    "prom.assign_hint":       "選擇此主管管理的促銷員：",
    "prom.no_promoters":      "暫無促銷員",
    "prom.no_supervisors":    "暫無主管",
    "prom.archive":           "封存",
    "prom.restore":           "還原",
    "prom.archived_badge":    "已封存",
    "prom.show_archived":     "顯示已封存",
    "prom.confirm_archive":   "此促銷員將被隱藏。歷史資料仍會保留。是否繼續？",
    "prom.created_ok":        "帳號建立成功",
    "prom.updated_ok":        "更新成功",
    "prom.sv_created_ok":     "主管建立成功",
    "prom.reset_confirm":     "傳送密碼重設郵件至",
    "prom.reset_ok":          "✅ 重設郵件已傳送至",
    "prom.assign_ok":         "已更新組員列表，主管：",

    // ── Targets ──────────────────────────────────────────────
    "target.title":           "目標與獎金",
    "target.title_sv":        "設定目標",
    "target.subtitle":        "管理月度銷售目標",
    "target.subtitle_sv":     "為促銷員設定月度銷售目標",
    "target.sell_target":     "銷售目標",
    "target.he_target":       "高端目標",
    "target.not_set":         "未設定",
    "target.save_ok":         "已儲存目標，促銷員：",

    // ── Holidays ─────────────────────────────────────────────
    "holiday.title":          "國定假日",
    "holiday.subtitle":       "管理國家法定假日",
    "holiday.add":            "+ 新增假日",
    "holiday.name":           "假日名稱",
    "holiday.date":           "日期",
    "holiday.multiplier":     "薪資倍率",
    "holiday.no_holidays":    "暫無假日",
    "holiday.delete_confirm": "刪除此假日？",

    // ── SKUs ─────────────────────────────────────────────────
    "sku.title":              "SKU產品",
    "sku.subtitle":           "管理產品目錄",
    "sku.subtitle_lookup":    "查詢MSI筆記型電腦規格",
    "sku.add":                "+ 新增SKU",
    "sku.model":              "型號",
    "sku.brand":              "品牌",
    "sku.cpu":                "處理器",
    "sku.gpu":                "顯示卡",
    "sku.ram":                "記憶體",
    "sku.ssd":                "固態硬碟",
    "sku.lcd":                "螢幕",
    "sku.battery":            "電池",
    "sku.ports":              "連接埠",
    "sku.upgradeable":        "可升級",
    "sku.highend":            "高端",
    "sku.no_skus":            "暫無SKU",
    "sku.delete_confirm":     "刪除此SKU？",
    "sku.search_placeholder": "依型號搜尋...",

    // ── Notifications ────────────────────────────────────────
    "notif.title":            "通知",
    "notif.subtitle":         "向促銷員傳送通知",
    "notif.title_field":      "標題",
    "notif.body":             "內容",
    "notif.send_to":          "傳送至",
    "notif.all_promoters":    "全部促銷員",
    "notif.all_group":        "全組（{n}人）",
    "notif.select_specific":  "指定人員",
    "notif.select_promoters": "選擇促銷員",
    "notif.attachment":       "📎 附件",
    "notif.send_btn":         "📢 傳送通知",
    "notif.sent_ok":          "✅ 通知傳送成功！",
    "notif.no_notifs":        "暫無通知",
    "notif.from_admin":       "管理員通知",
    "notif.empty_fields":     "請輸入標題和內容。",
    "notif.select_at_least":  "請至少選擇1名促銷員。",
    "notif.placeholder_title":"通知標題",
    "notif.placeholder_body": "通知內容...",
    "notif.upload_file":      "📎 附加檔案（選填）",
    "notif.submit_title":     "向促銷員發送通知",
    "notif.all_supervisors":  "全部主管",

    // ── Bonus Rules ──────────────────────────────────────────
    "bonus.title":            "獎金規則",
    "bonus.subtitle":         "設定銷售和高端獎金級距",
    "bonus.sales_tiers":      "銷售獎金級距",
    "bonus.he_tiers":         "高端獎金級距",
    "bonus.programs":         "獎金活動",
    "bonus.min_rate":         "最低達成率（%）",
    "bonus.amount":           "獎金（越盾）",
    "bonus.add_tier":         "+ 新增級距",
    "bonus.program_name":     "活動名稱",
    "bonus.start_date":       "開始日期",
    "bonus.end_date":         "結束日期",
    "bonus.skus_list":        "適用型號（逗號分隔）",
    "bonus.per_unit":         "每台獎金（越盾）",
    "bonus.add_program":      "+ 新增活動",
    "bonus.save_config":      "儲存設定",

    // ── Audit Log ────────────────────────────────────────────
    "audit.title":            "操作記錄",
    "audit.subtitle":         "銷售審核和目標設定歷史",
    "audit.type":             "類型",
    "audit.actor":            "操作人",
    "audit.promoter":         "促銷員",
    "audit.detail":           "詳情",
    "audit.time":             "時間",
    "audit.sale_approved":    "審核銷售",
    "audit.sale_rejected":    "拒絕銷售",
    "audit.sale_cancelled":   "取消已核准訂單",
    "audit.income_imported":  "匯入歷史收入",
    // ── 新模組 ──
    "audit.login": "登入", "audit.logout": "登出", "audit.password_changed": "修改密碼",
    "audit.promoter_created": "建立推廣員", "audit.promoter_updated": "編輯推廣員",
    "audit.promoter_archived": "封存推廣員", "audit.promoter_restored": "恢復推廣員",
    "audit.supervisor_created": "建立主管", "audit.assignment_changed": "主管分配變更",
    "audit.sale_submitted": "提交訂單", "audit.bonus_config_saved": "修改獎金規則",
    "audit.event_bonus_added": "新增活動包干", "audit.event_bonus_deleted": "刪除活動包干",
    "audit.sku_added": "新增SKU", "audit.sku_deleted": "刪除SKU",
    "audit.holiday_added": "新增節日", "audit.holiday_deleted": "刪除節日",
    "audit.banner_saved": "更新橫幅", "audit.banner_deleted": "刪除橫幅",
    "audit.training_added": "新增培訓資料", "audit.training_updated": "編輯培訓資料", "audit.training_deleted": "刪除培訓資料",
    "audit.sale_approval_reverted": "撤回核准", "audit.target_approved": "核准目標",
    "audit.payroll_adjusted": "調整工數", "audit.payroll_closed": "薪資結算", "audit.payroll_reopened": "重新開啟薪資",
    "x.status": "狀態", "x.month": "月份", "x.note": "備註", "x.records": "筆紀錄",
    "sales.status_pending2": "⏳ 待審核", "sales.status_approved2": "✓ 已核准",
    "sales.status_rejected2": "✕ 已拒絕", "sales.status_cancelled2": "🚫 已取消",
    "sales.cancel_pending2": "🕓 取消待審", "sales.rejected_badge": "已拒絕",
    "sales.cancel_prompt": "取消原因（例：客戶棄訂）：",
    "sales.search_ph": "🔍 搜尋推廣員／型號／序號…",
    "sales.orders_unit": "筆", "sales.revert": "↩ 撤回",
    "sales.revert_hint": "撤回核准——訂單回到待審核",
    "sales.revert_confirm": "撤回此核准？訂單將回到待審核。",
    "sales.dup_serial": "⚠ 序號曾提交：", "sales.dup_others": "其他",
    "sales.toggle_he": "點擊切換高階", "sales.he_yes": "是 ✎", "sales.he_no": "否 ✎",
    "sales.locked_badge": "🔒 已結算", "sales.no_cancel_reqs": "沒有取消請求",
    "sales.month_locked_view": "🔒 本月薪資已結算——僅供查看。",
    "sales.closing_notice": "⏳ 補登上月銷售——截止日：5號。",
    "sales.locked_title": "本月薪資已結算",
    "sales.locked_sub": "僅可查看歷史紀錄。",
    "sales.current_tag": "（本月）",
    "ps.mode_list": "從清單選", "ps.mode_search": "搜尋", "ps.mode_camera": "AI拍照",
    "att.shift_label": "今日班別", "att.shift_full": "全班（{h}小時）", "att.shift_half": "半班（{h}小時）",
    "att.shift_half_note": "半班計0.5工，底薪相應減少",
    "att.msg_compress": "📦 壓縮照片中…", "att.msg_upload": "⬆ 上傳照片並取得GPS…", "att.msg_saving": "⏳ 登記中…",
    "ah.pending_mode": "待審核", "ah.history_mode": "📜 歷史", "ah.count": "申訴",
    "ah.none": "沒有申訴", "ah.admin_note": "管理員備註", "ah.reviewed_at": "處理時間",
    "ah.export": "⬇ 匯出CSV", "ah.st_pending": "待審核", "ah.st_approved": "已核准", "ah.st_rejected": "已拒絕",
    "ah.legend_appeal": "有申訴（滑鼠懸停查看）",
    "attm.title": "⚙️ 特殊薪資調整",
    "attm.leave_title": "🌴 帶薪休假（主管核准）", "attm.leave_note": "未打卡仍計1全工",
    "attm.event_title": "🎪 場外活動包干", "attm.event_name": "活動名稱", "attm.amount": "金額", "attm.add": "+ 新增",
    "train.subtitle": "培訓資料與指南", "train.add_title": "➕ 新增資料", "train.edit_title": "✏️ 編輯資料",
    "train.date": "日期", "train.title_lb": "標題", "train.content": "內容",
    "train.link": "連結（Google Drive／URL）", "train.save_change": "儲存變更", "train.add_btn": "新增資料",
    "train.list": "資料清單", "train.none": "尚無培訓資料", "train.open": "📄 開啟資料",
    "train.need_title": "請輸入標題", "train.saved": "✅ 已儲存", "train.del_confirm": "刪除此資料？",
    "tga.pending_title": "🎯 待審目標", "tga.proposed_by": "提案主管",
    "tga.ds_prop": "提案銷售", "tga.he_prop": "提案高階", "tga.ds_final": "核定銷售", "tga.he_final": "核定高階",
    "tga.approve": "✓ 核准", "tga.adjusted": "（已調整）",
    "tga.hint": "💡 核准前可修改數字——主管與推廣員將收到最終數字通知。",
    "tga.sv_subtitle": "提案目標——經管理員核准後生效",
    "tga.wait": "⏳ 待管理員核准", "tga.approved": "✓ 已核准", "tga.adj_note": "管理員調整",
    "tga.locked": "🔒 請聯繫管理員修改", "tga.send": "送出提案", "tga.propose": "+ 提案",
    "pr.title": "📝 審核與結算",
    "pr.subtitle": "結算前調整工數／獎金——全域生效。",
    "pr.close": "🔒 本月結算", "pr.reopen": "🔓 重新開啟", "pr.closed_at": "✅ 已結算",
    "pr.locked_note": "——調整已鎖定。", "pr.pick_promoter": "— 選擇推廣員 —",
    "pr.days_ph": "± 工數（如1或-0.5）", "pr.bonus_ph": "± 活動獎金（₫）",
    "pr.note_ph": "備註（如年假、補獎金）", "pr.save": "+ 儲存調整",
    "pr.close_confirm": "結算本月薪資？調整將鎖定。",
    "pr.reopen_confirm": "重新開啟本月薪資？",
    "salary.allowance": "津貼",
    "cc.title": "💼 公司總成本（透過代理）", "cc.config": "⚙ 設定",
    "cc.si": "公司社保", "cc.hi": "公司醫保", "cc.ui": "失業保險",
    "cc.union": "工會費", "cc.pai": "意外保險",
    "cc.gross": "員工總收入（Gross）", "cc.ins_total": "公司保險費用合計",
    "cc.mgmt": "服務管理費", "cc.total": "💰 公司總成本",
    "cc.save_cfg": "💾 儲存設定", "cc.tiers": "依人數的管理費（₫/人/月）",
    "inc.title": "💰 收入紀錄", "inc.m3": "3個月", "inc.m6": "6個月", "inc.m12": "12個月",
    "inc.sold": "已售", "inc.net": "實領", "inc.detail": "詳情 ⓘ", "inc.provisional": "（暫計）",
    "inc.total_range": "總計", "inc.loading": "計算收入中…",
    "inc.modal_title": "收入明細", "inc.work_pay": "工資",
    "inc.total_income": "總收入", "inc.pretax_note": "稅前及保險前收入。",
    "inc.provisional_note": "暫計至今日——月底前數字仍會變動。",
    "inc.company_ins": "🏢 公司繳納保險（不扣薪）",
    "inc.emp_ins": "👤 個人繳納保險（扣薪）",
    "inc.total_company": "公司合計", "inc.total_emp": "個人合計",
    "inc.tax_section": "🧾 個人所得稅", "inc.taxable": "應稅收入", "inc.pit": "個稅",
    "inc.no_tax": "收入低於15,500,000₫→免繳個稅。",
    "inc.no_breakdown": "稅務／保險明細尚未提供——請管理員重新匯入Excel。",
    "inc.gross_lb": "總收入（Gross）",
    "x.workday": "工",
    "salary.export_xlsx": "⬇ 匯出Excel（完整）",
    "salary.ot_nontax": "免稅加班費",
    "inc.ot_exempt": "減免稅加班費",
    "cc.usd_rate": "美元匯率（đ）",
    "pr.ot_ph": "± 免稅加班費（đ）",
    "sales.locked_approve_warn": "{month} 已過結帳期限。核准取消將減少該月業績與獎金，已結算的薪資數字會改變。仍要繼續？",
    "sales.locked_hint": "該月已結帳 — 僅管理員可核准取消。您仍可拒絕此申請。",
    "audit.sale_cancel_rejected": "拒絕取消申請",
    "sku.clear_filters": "清除篩選",
    "cfg.ot_tiers": "三種加班費率（勞動法第98條）",
    "cfg.ot_tiers_note": "時薪的 %，僅於事先申請並核准（若需核准）時計算。",
    "cfg.weekly_off_ot": "週休日上班",
    "cfg.weekly_off_ot_hint": "法定最低 200%，該日不計為一般工作日。",
    "cfg.edit_in_ot_tab": "（請於「工時與加班」分頁修改）",
    "ot.kind": "加班類型",
    "ot.kind_extra": "延長工時",
    "ot.kind_weekly_off": "週休日上班",
    "ot.note_weekly_off": "週休日上班：依實際工時（上限為申請時數）按週休日費率計算，不計為一般工作日。",
    "pay.weekly_off": "週休日上班",
    "cfg.rate_hours": "時薪換算時數",
    "cfg.rate_hours_hint": "時薪 = 底薪 ÷ 標準工作天數 ÷ 此時數（代理商使用 8）",
    "ot.kind_holiday": "國定假日上班",
    "ot.note_holiday": "國定假日：所有工時均按假日費率計算，但須事先申請並核准 — 未申請不計。請填寫當日總工時（含超出班次的時數）。",
    "ot.admin_title": "加班／假日工時（管理員輸入）",
    "ot.admin_current": "目前：{kind} {h} 小時",
    "ot.by_admin": "管理員輸入",
    "ot.hours_unit": "小時",
    "ot.admin_note_ph": "備註（例：依代理商薪資表）",
    "ot.admin_hint_holiday": "國定假日總工時 — 全部按假日費率計算。管理員輸入的時數照實使用。",
    "ot.admin_hint_weekly_off": "週休日總工時 — 按週休日費率計算，該日不計為一般工作日。",
    "ot.admin_hint_extra": "超出標準班次的時數 — 按平日加班費率計算。",
    "ot.admin_save": "儲存（已核准）",
    "ot.admin_update": "更新",
    "ot.admin_delete": "刪除",
    "ot.admin_hours_err": "時數須大於 0 且不超過 24",
    "inc.probation_flat_note": "試用期內 — 尚未參加保險；按總收入（含加班）扣繳 {pct}% 稅款，不適用家庭扣除額。",
    "tax.probation_mode": "試用期稅務",
    "tax.probation_flat": "按總收入固定 % 扣繳",
    "tax.probation_prog": "累進稅率，無家庭扣除",
    "tax.probation_flat_hint": "代理商現行做法：% × 總收入（含加班），無扣除額。",
    "tax.probation_prog_hint": "與正式員工相同累進稅率，但無家庭扣除額。",
    "tax.probation_rate": "試用期扣繳率",
    "tax.probation_min": "收入低於此數不扣繳",
    "nav.bonus_programs": "獎勵活動",
    "prog.created_notified": "已建立活動並通知所有促銷員與主管 ✓",
    "bp.title": "獎勵活動",
    "bp.sub_promoter": "按機型的獎勵活動 — 你的銷售台數與預估獎金",
    "bp.sub_supervisor": "按機型的獎勵活動 — 你的團隊銷售台數",
    "bp.running": "進行中",
    "bp.upcoming": "即將開始",
    "bp.history": "已結束",
    "bp.none_running": "目前沒有進行中的活動",
    "bp.none_ended": "尚無已結束的活動",
    "bp.st_running": "進行中",
    "bp.st_upcoming": "即將開始",
    "bp.st_ended": "已結束",
    "bp.days_left": "剩 {n} 天",
    "bp.last_day": "最後一天",
    "bp.starts_in": "{n} 天後開始",
    "bp.per_unit": "每台獎金",
    "bp.my_units": "你已售出",
    "bp.my_bonus": "預估獎金",
    "bp.team_units": "你的團隊（{team} 位促銷員）已售出：{n} 台",
    "bp.models": "適用 {n} 個機型",
    "bp.more": "+{n} 個機型",
    "bp.less": "收合",
    "bp.view": "查看活動",
    "bp.note": "僅計算已核准、機型相符且銷售日在活動期間內的訂單。正式金額以當月薪資表為準。",
    "prog.edit": "編輯",
    "prog.revoke": "撤回",
    "prog.restore": "恢復",
    "prog.edit_title": "編輯活動：{name}",
    "prog.edit_note": "儲存後會通知所有促銷員與主管並列出變更內容。薪資表中的獎金將依新資料重新計算。",
    "prog.save_edit": "儲存變更並通知",
    "prog.bad_dates": "結束日須晚於或等於開始日",
    "prog.updated_notified": "已更新活動並通知所有促銷員與主管 ✓",
    "prog.revoke_prompt": "撤回活動「{name}」？\n\n撤回後，此活動對任何訂單（包括已售出的）都不再計算獎金。若只想提前結束，請按取消並修改結束日。\n\n撤回原因（會附在通知中，可留空）：",
    "prog.revoked_notified": "已撤回活動並通知所有人 ✓",
    "prog.restore_confirm": "重新套用活動「{name}」？獎金將重新計算並通知所有人。",
    "prog.restored_notified": "已恢復活動並通知所有人 ✓",
    "prog.revoked_title": "已撤回的活動",
    "prog.reason": "原因",
    "prog.closed_warn": "{months} 的薪資已結帳。此變更將改變已結帳薪資中的獎金。仍要繼續嗎？",
    "bp.st_revoked": "已撤回",
    "bp.revoked_note": "此活動已撤回，不再計算獎金",
    "bp.updated_at": "更新於 {d}",
    "skm.upload": "上傳規格主檔",
    "skm.busy": "處理中...",
    "skm.panel_title": "上傳 MSI 規格主檔",
    "skm.reading": "正在讀取 {name}...",
    "skm.no_products": "檔案中找不到 SKU（Part No 以 9S7- 開頭）",
    "skm.found": "工作表 {sheet}：{n} 個 SKU、{cols} 個規格欄位。確認無誤後按「確認」。",
    "skm.k_new": "新增",
    "skm.k_changed": "變更",
    "skm.k_back": "重新上架",
    "skm.k_same": "未變更",
    "skm.k_leaving": "停止供貨",
    "skm.leaving_note": "主檔中已不存在的 SKU 將標記為「停止供貨」：促銷員查詢時隱藏，過去的銷售與活動不受影響。",
    "skm.skipped": "略過 {n} 列 Part No 非 9S7- 開頭的資料",
    "skm.keep_note": "現有 SKU 的 Highend 設定與管理員備註會保留。新 SKU 依 GPU 自動判定 Highend。",
    "skm.confirm": "確認 {n} 個 SKU",
    "skm.applying": "儲存中...",
    "skm.done": "完成：新增 {added}、更新 {updated}、停止供貨 {disc}。",
    "skm.current": "目前主檔：{name} · {n} 個 SKU · {d}",
    "skm.none": "尚未上傳規格主檔",
    "skm.st_active": "供貨中",
    "skm.st_disc": "停止供貨",
    "skm.st_all": "全部 SKU",
    "skm.master_cols": "主檔欄位",
    "skm.empty": "尚無 SKU。請按「📤 上傳規格主檔」。",
    "skm.remap_confirm": "要用已儲存的主檔規格，依新設定更新 SKU 表格欄位嗎（不需重新上傳）？",
    "skm.remapped": "已依新設定更新 {n} 個 SKU。",
    "spec.msi_standard": "MSI 標準規格",
    "spec.show_all": "查看全部規格",
    "spec.hide_all": "收合",
    "spec.no_master": "此 SKU 尚未在規格主檔中 — 顯示基本資訊。",
    "nav.reports": "銷售報表",
    "rpt.title": "銷售報表",
    "rpt.subtitle": "跨月份依促銷員、機型與區隔的總覽 — 對照目標",
    "rpt.from": "起始月",
    "rpt.to": "結束月",
    "rpt.last_n": "{n} 個月",
    "rpt.all_promoters": "全部促銷員",
    "rpt.units": "銷售台數",
    "rpt.months": "個月",
    "rpt.vs_target": "目標達成",
    "rpt.highend": "Highend 台數",
    "rpt.active_promoters": "有資料的促銷員",
    "rpt.trend": "每月銷售",
    "rpt.sold": "已售",
    "rpt.tab_promoter": "依促銷員",
    "rpt.tab_model": "依機型",
    "rpt.tab_mix": "區隔組成",
    "rpt.promoter_hint": "每格：已售 / 目標、達成 % 與 Highend。點促銷員名稱查看每月明細。",
    "rpt.total": "合計",
    "rpt.hit": "達成",
    "rpt.near": "接近",
    "rpt.miss": "未達成",
    "rpt.imported": "匯入",
    "rpt.imported_note": "斜體：舊月份使用匯入數據（無機型明細）。",
    "rpt.model_search": "搜尋機型或區隔...",
    "rpt.segment": "區隔",
    "rpt.no_sales": "此期間沒有已核准的銷售",
    "rpt.model_note": "僅計算 App 內已核准的銷售。促銷員欄：賣過此機型的促銷員人數。",
    "rpt.classify_by": "分類依據",
    "rpt.by_segment": "產品線（Segment）",
    "rpt.by_series": "群組（Gaming / Business）",
    "rpt.whole_range": "整個所選期間",
    "rpt.mix": "組成",
    "rpt.mix_note": "區隔取自 SKU 規格（主檔）。對不到 SKU 的機型列為「未分類」；小區隔併入「其他」。",
    "rpt.unknown": "未分類",
    "rpt.other": "其他",
    "rpt.top_models": "熱銷機型",
    "prom.salary_from": "新薪資自此月份起適用",
    "prom.salary_from_note": "此月份之前仍按原金額（{old} ₫）計算；本月及之後按新金額。",
    "prom.salary_saved": "已儲存新薪資，自 {month} 起適用",
    "prom.salary_history": "底薪歷史",
    "prom.salary_initial": "初始",
    "prom.salary_from_m": "自 {m}",
    "prom.salary_past_warn": "自 {month} 起追溯適用：過去月份（包括已結帳月份）的薪資將按新金額重算。要繼續嗎？",
    "nav.settings": "設定",
    "cfg.title": "設定",
    "cfg.subtitle": "出勤、薪資、稅務與成本的所有規則 — 集中於一處",
    "cfg.tab_work": "工時與加班",
    "cfg.tab_holiday": "國定假日、春節與有薪假",
    "cfg.tab_bonus": "獎金",
    "cfg.tab_tax": "稅務與保險",
    "cfg.tab_cost": "代理成本",
    "cfg.tab_rules": "其他規定",
    "cfg.effective_from": "生效月份",
    "cfg.editing_existing": "正在編輯自 {month} 起生效的版本，儲存將覆寫此版本。",
    "cfg.creating_new": "{month} 尚無專屬版本 — 儲存後將建立自 {month} 起生效的新版本，之前月份維持原規則。",
    "cfg.save": "儲存，自 {month} 生效",
    "cfg.saved": "已儲存，新規則自 {month} 起適用。",
    "cfg.past_warn": "{month} 已過。儲存將改變 {month} 及之後月份的薪資，確定繼續？",
    "cfg.delete_confirm": "刪除自 {month} 起生效的版本？這些月份將回到前一版本。",
    "cfg.history": "變更紀錄",
    "cfg.no_versions": "尚無版本 — 所有月份皆依原規則計算。",
    "cfg.from": "自",
    "cfg.legacy_note": "第一個版本之前的月份依原規則計算（每班8小時、假日×3、無加班），以符合已發放的薪資。",
    "cfg.standard_days": "每月標準工作天數",
    "cfg.standard_days_hint": "日薪 = 底薪 ÷ 此數",
    "cfg.standard_hours": "每日標準工時",
    "cfg.standard_hours_hint": "達到即算全勤；超過部分才可能算加班",
    "cfg.half_shift": "半班工時",
    "cfg.half_shift_hint": "半班計 0.5 工",
    "cfg.tolerance": "工時不足容許值",
    "cfg.tolerance_hint": "不足不超過此時數仍算全勤（0 = 須足時）",
    "cfg.ot_rate": "平日加班",
    "cfg.ot_rate_hint": "時薪的 % — 法定最低 150%",
    "cfg.ot_approval": "加班申請須經主管核准才計薪",
    "cfg.ot_tax_exempt": "加班費與國定假日出勤費免繳個人所得稅（2025 年個人所得稅法）",
    "cfg.example_work": "底薪 6,500,000đ → 日薪 {daily}đ、時薪 {hourly}đ（÷ {h} 小時）、加班 1 小時 = {ot}đ",
    "cfg.holiday_paid": "國定假日工資",
    "cfg.holiday_paid_hint": "日薪的 % — 無論是否上班皆可領",
    "cfg.holiday_ot": "國定假日、春節、有薪假上班",
    "cfg.holiday_ot_hint": "時薪的 %，適用所有已申請的假日工時 — 法定最低 300%，另計假日工資",
    "cfg.example_holiday": "假日休息：日薪 {off}% · 假日上班：日薪 {on}%",
    "cfg.holiday_list_note": "假日清單立即生效，不分版本。",
    "cfg.people": "人",
    "cfg.person": "人",
    "cfg.closing_day": "結帳日",
    "cfg.closing_day_hint": "上個月可修改至此日結束",
    "cfg.max_appeals": "每月核准申訴上限",
    "cfg.max_appeals_hint": "每位促銷員",
    "cfg.remind_hour": "下班打卡提醒時間",
    "cfg.remind_hour_hint": "未打卡下班者將收到通知",
    "ot.title": "申請加班",
    "ot.hours": "加班時數",
    "ot.note": "僅超過 {h} 小時的部分計為加班，上限為申請時數。",
    "ot.reason_ph": "例如：促銷活動、盤點…",
    "ot.submit": "送出申請",
    "ot.registered": "已申請加班 {h} 小時",
    "ot.st_pending": "待核准",
    "ot.st_approved": "已核准",
    "ot.withdraw": "撤回",
    "ot.pending_title": "待核准加班申請",
    "pay.incl_holiday": "含 {n} 天國定假日",
    "pay.holiday_pay": "國定假日工資",
    "pay.holiday_ot": "假日上班",
    "pay.ot": "加班",
    "audit.payroll_config_saved": "儲存設定",
    "audit.payroll_config_deleted": "刪除設定版本",
    "audit.ot_requested": "申請加班",
    "audit.ot_approved": "核准加班",
    "audit.ot_rejected": "拒絕加班",
    "audit.ot_withdrawn": "撤回加班",
    "att.st_full": "全勤",
    "att.st_missing": "缺打卡",
    "att.st_short": "工時不足",
    "att.st_holiday": "國定假日",
    "att.st_annualLeave": "年假",
    "att.st_unpaidLeave": "無薪假",
    "att.st_weeklyOff": "週休",
    "att.st_future": "未到",
    "lv.title": "請假申請",
    "lv.type": "請假類型",
    "lv.unpaid": "無薪假",
    "lv.annual_note": "扣除年假額度，仍計1全工。",
    "lv.unpaid_note": "不計工、當日不支薪。",
    "lv.reason": "事由",
    "lv.reason_ph": "例如：家庭事務、就醫……",
    "lv.approval_note": "申請將送交主管，核准後才生效。",
    "lv.submit": "送出申請",
    "lv.book_hint": "點選未來日期即可請假",
    "lv.pending_hint": "請假申請待主管核准",
    "lv.pending_short": "待核准",
    "lv.pending_title": "待核准請假申請",
    "lv.approve": "核准",
    "lv.reject": "拒絕",
    "audit.leave_requested": "提出請假",
    "audit.leave_approved": "核准請假",
    "audit.leave_rejected": "拒絕請假",
    "inc.probation_note": "試用期內 — 尚未參加保險，也不適用家庭扣除額。",
    "inc.meal_exempt": "減免稅伙食津貼",
    "inc.personal_ded": "本人扣除額",
    "inc.dependent_ded": "扶養親屬扣除額",
    "inc.taxable_base": "計稅所得",
    "cc.ins_base": "投保薪資", "cc.insured": "參保",
    "cc.show_detail": "▸ 個人明細", "cc.hide_detail": "▾ 收合",
    "cc.detail_note": "點擊薪資欄可覆寫當月投保金額 · 取消勾選則排除參保",
    "cc.export_detail": "⬇ 匯出CSV",
    "cc.probation_until": "試用期至",
    "cc.under14_note": "當月工作未滿14天 — 法律允許當月不參保",
    "tax.title": "🧾 個人所得稅與保險設定",
    "tax.legal_note": "個人所得稅法2025 (109/2025/QH15) · 決議110/2025 · 議定253/2026",
    "tax.personal_ded": "本人扣除額（đ/月）",
    "tax.dependent_ded": "扶養親屬扣除額（đ/月）",
    "tax.meal_cap": "伙食免稅上限（đ/月）",
    "tax.probation_months": "試用期（月）",
    "tax.emp_si": "員工社保 (%)", "tax.emp_hi": "員工健保 (%)", "tax.emp_ui": "員工失業保險 (%)",
    "tax.emp_total": "員工負擔", "tax.brackets": "累進稅率級距", "tax.tier": "級距",
    "tax.up_to": "上限（đ/月）", "tax.tiers_count": "個級距",
    "tax.up_to_note": "最後一級的「上限」留空 = 無上限。",
    "prom.start_date": "到職日", "prom.dependents": "扶養親屬人數",
    "prom.start_date_note": "用於判定試用期（不參加保險）。",
    "prom.dependents_note": "每位扶養親屬可享個人所得稅扣除額。",
    "prom.probation": "試用期", "prom.no_start_date": "未填到職日 — 視為已過試用期",
    "audit.tax_config_saved": "修改稅務設定", "audit.insurance_adjusted": "調整保險",
    "inc.footnote": "* 「實領」已扣稅與保險。點擊月份查看詳情。本月為暫計。",
    "dash.overview": "月度總覽", "dash.total_promoters": "推廣員總數", "dash.total_sales": "總銷售",
    "dash.target_lb": "目標", "dash.avg_hit": "平均達成率", "dash.need80": "需≥80%才可獲獎金",
    "dash.pending_orders": "待審訂單", "dash.progress_title": "銷售進度", "dash.pending_title": "待審銷售",
    "dash.banner_size": "建議圖片尺寸：1200 × 400 px（3:1）——PC與手機皆適用",
    "dash.banner_title_ph": "標題", "dash.hello": "你好", "dash.group_note": "組內推廣員",
    "dash.appeals_pending": "待審申訴",
    "home.units": "台", "home.exp_bonus": "預計獎金", "home.exp_ds": "預計銷售獎金",
    "home.reached": "已達獎金門檻 ✓", "home.need_more": "還需", "home.more_units": "台",
    "home.progress": "月進度",
    "prog.add_title": "新增獎勵活動", "prog.name": "活動名稱", "prog.from": "開始日", "prog.to": "結束日",
    "prog.sku_apply": "適用SKU", "prog.selected": "已選", "prog.find_name": "依名稱搜尋…",
    "prog.all_gpu": "全部GPU", "prog.no_sku": "找不到符合的SKU",
    "prog.per_unit": "每台獎金（₫）", "prog.create": "建立活動",
    "prog.running": "進行中活動", "prog.none_running": "沒有進行中的活動",
    "prog.ended": "已結束活動",
    "prog.col_name": "名稱", "prog.col_time": "期間", "prog.col_bonus": "每台獎金",
    "prog.saved_target": "已儲存目標 ✓", "prog.created": "已建立活動 ✓",
    "prog.need_sku": "請至少選擇1個SKU",
    "rule.title": "固定獎金規則", "rule.col_type": "類型", "rule.col_cond": "條件", "rule.col_amount": "獎金",
    "rule.ds1": "銷售獎金一級", "rule.ds2": "銷售獎金二級", "rule.ds3": "銷售獎金三級",
    "rule.he_per": "高階獎金", "rule.he_cond": "每售出一台高階（從第一台起）", "rule.he_amount": "固定每台獎金",
    "rule.he_over": "高階超標獎金", "rule.he_over_cond": "每台超過個人目標", "rule.he_over_amount": "更高每台獎金（加速）",
    "rule.hint": "💡 高階獎金於「獎金規則」頁設定。按台計獎——各店公平。",
    "audit.sale_highend_changed": "變更高端標記",
    "audit.target_set":       "設定目標",
    "audit.filter_all":       "全部",
    "audit.filter_month":     "篩選月份",
    "audit.clear_month":      "✕ 清除篩選",
    "audit.cleanup_title":    "🧹 清理舊出勤照片",
    "audit.cleanup_desc":     "從Firebase Storage刪除打卡照片並清除Firestore中的連結。出勤資料（工時、日期）保留不變——僅刪除照片。",
    "audit.cleanup_3m":       "3個月前",
    "audit.cleanup_6m":       "6個月前",
    "audit.cleanup_12m":      "12個月前",
    "audit.cleanup_btn":      "🗑 開始清理",
    "audit.cleanup_running":  "刪除中... ({done}/{total})",
    "audit.cleanup_ok":       "✅ 已刪除 {n} 筆出勤記錄的照片。",
    "audit.cleanup_confirm":  "刪除{n}個月前的出勤照片？\n\n此操作不可撤銷，檔案將從Firebase Storage永久刪除。",
    "audit.admin_label":      "管理員",
    "audit.supervisor_label": "主管",
    "audit.notification_sent":    "發送通知",
    "audit.bonus_program_added":  "創建獎金活動",
    "audit.attendance_checkin":   "上班打卡",
    "audit.attendance_day_cleared": "取消休假標記",
    "audit.attendance_checkout":  "下班打卡",
    "audit.appeal_submitted":     "提交申訴",
    "audit.appeal_approved":      "核准申訴",
    "audit.appeal_rejected":      "拒絕申訴",

    // ── Banner ───────────────────────────────────────────────
    "banner.manage_title":    "管理橫幅",
    "banner.slot":            "位置",
    "banner.image_url":       "圖片URL",
    "banner.link_url":        "點擊連結",
    "banner.save":            "保存橫幅",
    "banner.clear":           "清除",
    "banner.upload_image":    "上傳圖片",
    "banner.no_banners":      "尚無橫幅",

    // ── Supervisor Dashboard ─────────────────────────────────
    "sv_dash.title":          "儀表板",
    "sv_dash.subtitle":       "團隊概覽",
    "sv_dash.my_group":       "我的團隊",
    "sv_dash.pending_sales":  "待審核銷售",
    "sv_dash.pending_appeals":"待處理申訴",
    "sv_dash.total_sales":    "本月總銷售",
    "sv_dash.promoter_list":  "促銷員列表",
    "sv_dash.no_promoters":   "尚未分配促銷員",

    // ── Promoter Home ────────────────────────────────────────
    "home.greeting":          "您好，",
    "home.subtitle":          "歡迎回來",
    "home.checkin_status":    "今日狀態",
    "home.not_checked_in":    "未打卡",
    "home.checked_in":        "已打上班卡",
    "home.checked_out":       "已打下班卡",
    "home.go_checkin":        "→ 去打卡",
    "home.this_month":        "本月",
    "home.days_worked":       "出勤天數",
    "home.sales_count":       "銷售數量",
    "home.pending_count":     "待審核",
  },
};

export default translations;
